document.addEventListener('alpine:init', () => {
    Alpine.data('quiz', () => {
        window.scrollTo({ top: -200, behavior: 'smooth' });
        const question_types = {
            SINGLE_IMG_2_COL: 'single_img_2_col',
            MULTIPLE_2_COL: 'multiple_2_col',
            SINGLE_1_COL: 'single_1_col',
            MULTIPLE_IMG_2_COL: 'multiple_img_2_col',
            SINGLE_HEADER_IMG_2_COL: 'single_header_img_2_col',
            SINGLE_ICONS: 'single_icons',
            MULTIPLE_ICONS_1_ROW: 'multiple_icons_1_row',
            SINGLE_IMG_1_ROW: 'single_img_1_row'
        };

        // ── Scoring configuration ───────────────────────────────────────────
        // 'points'     = weighted points per matching answer (see QUESTION_WEIGHTS).
        // 'fractional' = original system: matched / rules.length, where multi-select
        //                answers contribute fractional credit (matchCount / answers).
        const SCORING_MODE = 'points';        // 'points' | 'fractional'

        // Per-question point weights. Any question not listed defaults to 1.
        // To restore baseline behaviour, swap in the commented block below.
        const QUESTION_WEIGHTS = {
            2: 3,   // skincare concerns  (multi, up to 3 → max 9 pts)
            3: 3,   // age range          (single → max 3 pts)
            1: 2,   // skin type          (single → max 2 pts)
            5: 1,   // ingredients        (multi, exactly 2 → max 2 pts)
        };
        // ── Baseline weights (original) ──────────────────────────────────────
        // const QUESTION_WEIGHTS = {
        //     2: 2,   // skincare concerns only (all others default to 1)
        // };
        // ─────────────────────────────────────────────────────────────────────

        // Questions where a miss is a hard disqualification, not just a zero score.
        // Pass applyKnockouts=true to _getScoreBreakdown to enforce this for ritual building.
        // Carousel scoring leaves it false; to enable there, pass true from best() in carouselProducts.
        const KNOCKOUT_QUESTIONS = new Set([2, 3]);

        // Maps Q2 skincare concern tags to Moisturize product line names.
        // Used both for scoring bonuses and tie-breaking in the Moisturize slot.
        const MOISTURIZE_CONCERNS = [
            { concern: 'dsk-quiz-concerns-unhealthy-skin',    line: 'liposome' },
            { concern: 'dsk-quiz-concerns-loss-of-firmness',  line: 'aq' },
            { concern: 'dsk-quiz-concerns-thinning',          line: 'aq absolute' },
            { concern: 'dsk-quiz-concerns-sagging',           line: 'aq meliority' },
            { concern: 'dsk-quiz-concerns-hyperpigmentation', line: 'aq brightening' },
        ];

        return {
        question_types,
        storeUrl: "https://decortecosmetics.myshopify.com", // Replace with your actual Shopify store URL
        storefrontToken: "64204582ab21f41ceb76829dfe2a97c2", // Replace with your actual Storefront API access token
        interstitialOpen: false,
        interstitialOptionGroup: '',
        limitReached: false,
        footerObserver: null,
        footerHidden: false,
        footerScrollHandler: null,
        footerScrollSettleTimer: null,
        currentInterstitialHtml: '',
        currentStep: 0, // init to 0 for landing page
        quizCompleted: false,
        preResultsVisible: false,
        isLoggedIn: false,
        customerEmail: '',
        // ── Yotpo loyalty reward (via Klaviyo → Yotpo) ──
        // Yotpo custom action rule ID 1724178 awards 25 points for completing
        // the quiz. The storefront can't call the Yotpo API directly (secret
        // key + CORS), so completion fires a Klaviyo event using the public key
        // already loaded on this page. A Klaviyo flow triggered by this metric
        // calls Yotpo's "Record a Customer Action" endpoint via a webhook
        // action, with the x-guid/x-api-key credentials stored in Klaviyo.
        // The event fires for logged-in customers at quiz completion, and for
        // guests who sign up on the pre-results form (their Shopify account is
        // created by the Klaviyo signup, so Yotpo can attach the points to it).
        // The Yotpo rule must be capped to once per customer, since anyone can
        // fire client-side events (this also makes quiz retakes harmless).
        yotpoRewardSent: false,
        YOTPO_QUIZ_METRIC: 'Completed Skincare Quiz',
        signupComplete: false,
        klaviyoFormVisible: false,
        KLAVIYO_SIGNUP_FORM_ID: 'SQz6Y6', // pre-results signup embed (.klaviyo-form-SQz6Y6)
        quizLogicRules: {},
        apiError: false,
        debug: {
            step1: [],
            step2: [],
            step3: [],
            step4: []
        },
        init() {
            if (this.storefrontToken) {
                this.fetchAllQuizProducts().then(() => {
                    this.fetchSunscreenProduct();
                });
                this.fetchQuizLogicRules();
            }
            // Determine Shopify login state (set via data attributes in the section template).
            this.isLoggedIn = this.$root?.dataset?.customerLoggedIn === 'true';
            this.customerEmail = this.$root?.dataset?.customerEmail || '';
            // Klaviyo onsite form events for the pre-results signup embed. Filtered by
            // form ID so other Klaviyo forms on the site (popups, footer newsletter)
            // can't flip these flags. 'embedOpen' fires only when Klaviyo actually
            // displays the embed, so — unlike inspecting the div's children — it isn't
            // fooled by hidden markup injected for visitors the form's display
            // targeting excludes. 'submit'/'redirectedToUrl' → "Thanks for Subscribing" view.
            window.addEventListener('klaviyoForms', (e) => {
                console.log('[DSK Quiz debug] klaviyoForms event:', { type: e?.detail?.type, formId: e?.detail?.formId });
                if (e?.detail?.formId !== this.KLAVIYO_SIGNUP_FORM_ID) return;
                if (e.detail.type === 'embedOpen') {
                    this.klaviyoFormVisible = true;
                } else if (e.detail.type === 'submit' || e.detail.type === 'redirectedToUrl') {
                    this.signupComplete = true;
                    // A new signup at pre-results also earns the quiz-completion
                    // reward. 'submit' carries the submitted fields in metaData;
                    // if the email isn't there (e.g. 'redirectedToUrl'), the track
                    // still lands on the profile the form just identified.
                    this.triggerQuizCompletionReward(e.detail?.metaData?.$email || '');
                }
            });
            // The embed's target div sits behind x-show wrappers, hidden until the
            // pre-results view shows, so klaviyo.js doesn't mount the form on its
            // own page-load scan. Ask it to render explicitly the first time the
            // view shows. push([...]) queues safely if klaviyo.js hasn't loaded
            // yet, and if the form isn't live (or targeting excludes this visitor)
            // nothing renders and the view keeps its "See my results" fallback.
            // openForm renders an embed only ONCE per page load — that's why the
            // container uses x-show rather than x-if (the mounted form survives
            // "Retake the quiz" and reappears on the next pass), why
            // klaviyoFormVisible is never reset on hide, and why we skip the
            // openForm push when the form is already mounted.
            this.$watch('preResultsVisible', (visible) => {
                if (!visible) return;
                this.logPreResultsDebug('pre-results shown');
                if (this.signupComplete || this.klaviyoFormVisible) return;
                this.$nextTick(() => {
                    window._klOnsite = window._klOnsite || [];
                    window._klOnsite.push(['openForm', this.KLAVIYO_SIGNUP_FORM_ID]);
                });
                // Klaviyo mounts the embed asynchronously (or not at all, if its
                // display targeting excludes this visitor / consent blocks it) —
                // re-check after it has had time to respond so the console shows
                // whether embedOpen ever arrived.
                setTimeout(() => {
                    if (!this.preResultsVisible || this.klaviyoFormVisible) return;
                    const container = document.querySelector('.klaviyo-form-' + this.KLAVIYO_SIGNUP_FORM_ID);
                    console.log('[DSK Quiz debug] 3s after pre-results shown, Klaviyo form still not visible (no embedOpen event). Likely causes: form display targeting excludes this visitor (e.g. Klaviyo already recognises this browser as a subscribed profile via the __kla_id cookie), consent blocking, or the form is not live.', {
                        embedContainerInDom: !!container,
                        embedContainerChildCount: container ? container.children.length : null,
                    });
                    this.logPreResultsDebug('3s after pre-results shown');
                }, 3000);
            });
            // The theme nav's height is stable - it doesn't change as the page scrolls -
            // so there's no need to keep re-measuring during scroll. Continuously
            // rewriting the CSS var on every scroll frame was fighting with the browser's
            // own sticky positioning (especially on iOS Safari, where the URL bar
            // show/hide also shifts viewport coordinates mid-scroll), which is what
            // caused the AM/PM bar to jitter a few pixels above/below the nav during
            // quick scrolling. Instead, only recompute on genuine layout changes:
            // initial mount, viewport resize, and the email-banner dismiss/show.
            this.$nextTick(() => this.setHeaderOffset());
            window.addEventListener('resize', () => this.setHeaderOffset(), { passive: true });

            // Dismissing (or re-showing, on quiz restart) the email-capture banner
            // shifts the sticky header's in-flow position, so re-measure once the
            // DOM has settled into its new layout.
            this.$watch('emailCaptureVisible', () => {
                this.$nextTick(() => this.setHeaderOffset());
            });
        },
        setHeaderOffset() {
            let maxBottom = 0;

            // Rather than guessing the theme header's selector (which turned out to be
            // unreliable - it can miss whatever element the theme actually keeps pinned
            // to the top once scrolled, e.g. a cloned "sticky" nav with a different
            // class), detect it structurally: any element that is currently
            // position:fixed/sticky AND physically flush against the top of the
            // viewport is, by definition, part of the persistent chrome sitting above
            // our content. Exclude our own quiz elements so we don't measure ourselves.
            document.querySelectorAll('body *').forEach(el => {
                if (el.closest('.dsk-quiz')) return;
                const style = getComputedStyle(el);
                if (style.position !== 'fixed' && style.position !== 'sticky') return;
                const rect = el.getBoundingClientRect();
                if (rect.height === 0) return;
                if (rect.top > 1) return; // not flush with the viewport top
                // A real nav bar is a thin strip. Other fixed/sticky elements (cookie
                // banners, chat launchers, accessibility-widget containers that stay
                // full-height even while visually collapsed) can span most/all of the
                // viewport - exclude those so they can't hijack the measurement.
                if (rect.height > window.innerHeight * 0.35) return;
                if (rect.bottom > maxBottom) maxBottom = rect.bottom;
            });

            if (maxBottom > 0) {
                document.documentElement.style.setProperty('--quiz-sticky-top', `${maxBottom}px`);
                document.documentElement.style.setProperty('--header-height', `${maxBottom}px`);
            }
        },
        // Diagnostic dump for the pre-results page, to troubleshoot why the
        // Klaviyo signup form does / doesn't render for a given visitor.
        logPreResultsDebug(stage) {
            const getCookie = (name) => {
                const match = document.cookie.split(/;\s*/).find(c => c.startsWith(name + '='));
                return match ? decodeURIComponent(match.slice(name.length + 1)) : null;
            };
            // Klaviyo identity cookie — base64-encoded JSON. If it carries an
            // $exchange_id/$email, Klaviyo already recognises this browser as a
            // known profile even when the Shopify session is logged out, which can
            // make the form's display targeting (e.g. "don't show to existing
            // subscribers") suppress the embed.
            let klaviyoIdentity = getCookie('__kla_id');
            if (klaviyoIdentity) {
                try { klaviyoIdentity = JSON.parse(atob(klaviyoIdentity)); } catch (e) { /* keep raw value */ }
            }
            const privacyApi = window.Shopify && window.Shopify.customerPrivacy;
            let privacy = 'Shopify.customerPrivacy not present';
            if (privacyApi) {
                try {
                    privacy = {
                        analyticsAllowed: privacyApi.analyticsProcessingAllowed && privacyApi.analyticsProcessingAllowed(),
                        marketingAllowed: privacyApi.marketingAllowed && privacyApi.marketingAllowed(),
                        preferencesAllowed: privacyApi.preferencesProcessingAllowed && privacyApi.preferencesProcessingAllowed(),
                        saleOfDataAllowed: privacyApi.saleOfDataAllowed && privacyApi.saleOfDataAllowed(),
                        currentVisitorConsent: privacyApi.currentVisitorConsent && privacyApi.currentVisitorConsent(),
                    };
                } catch (e) {
                    privacy = 'error reading Shopify.customerPrivacy: ' + e.message;
                }
            }
            console.log('[DSK Quiz debug] pre-results state (' + stage + '):', {
                isLoggedIn: this.isLoggedIn,
                rootDatasetCustomerLoggedIn: this.$root && this.$root.dataset ? this.$root.dataset.customerLoggedIn : undefined,
                customerEmail: this.customerEmail,
                signupComplete: this.signupComplete,
                klaviyoFormVisible: this.klaviyoFormVisible,
                viewRendered: this.signupComplete
                    ? 'thanks view — signup form intentionally not rendered'
                    : (this.klaviyoFormVisible ? 'signup view with Klaviyo form' : 'signup view, waiting on Klaviyo embedOpen'),
                klaviyoJsLoaded: typeof window.klaviyo !== 'undefined' || typeof window._learnq !== 'undefined',
                klOnsiteQueueLength: Array.isArray(window._klOnsite) ? window._klOnsite.length : 'not created',
                klaviyoIdentityCookie: klaviyoIdentity || 'none',
                shopifyCustomerPrivacy: privacy,
                trackingConsentCookie: getCookie('_tracking_consent') || 'none',
                consentRelatedCookies: document.cookie.split(/;\s*/)
                    .map(c => c.split('=')[0])
                    .filter(n => /consent|privacy|cmp|optanon|onetrust|cookieyes|gdpr|ccpa/i.test(n)),
            });
        },
        // "Watch a how to video" modal (shared across all ritual product cards)
        howToVideoOpen: false,
        howToVideoSources: [],
        openHowToVideo(sources) {
            if (!sources || sources.length === 0) return;
            this.howToVideoSources = sources;
            this.howToVideoOpen = true;
        },
        closeHowToVideo() {
            this.howToVideoOpen = false;
            this.howToVideoSources = [];
        },
        activeRoutine: 'AM', // Track the selected routine
        ritualProducts: {
            'AM': [],
            'PM': []
        },
        ritualStepGroups: {
            'AM': [],
            'PM': []
        },
        ritualCollection: {
            'AM': null,
            'PM': null
        },
        resultStepLabels: [
            'Cleanse',
            'Repair',
            'Moisturize',
            'Eye Care'
        ],
        allProducts: {}, // This will hold all products fetched for easy access when applying rules
        rawAllProducts: [], // Flat array of all products for carousel and sunscreen lookups
        async fetchAllQuizProducts() {  
            let allProductMeta = [];
            let hasNextPage = true;
            let cursor = null;

            while (hasNextPage) {
                const query = `
                    query fetchAllQuizProductsMeta {
                      metaobjects(type: "dsk_quiz_product_meta", first: 250 ${cursor ? `, after: "${cursor}"` : ''}) {
                        pageInfo {
                          hasNextPage
                          endCursor
                        }
                        edges {
                          node {
                            id
                            ritual_step: field(key: "ritual_step") { value }
                            double_cleanse_step: field(key: "double_cleanse_step") { value }
                            carousel: field(key: "carousel") { value }
                            carousel_excl_layering: field(key: "carousel_excl_layering") { value }
                            carousel_category: field(key: "carousel_category") { value }
                            am_pm: field(key: "am_pm") { value }
                            product_lines: field(key: "product_lines") { value }
                            product: field(key: "product") {
                              reference {
                                ... on Product {
                                  id
                                  title
                                  handle
                                  featuredImage { url altText }
                                  priceRange { minVariantPrice { amount currencyCode } }
                                  descriptor: metafield(key: "Descriptor", namespace: "custom") { value }
                                  keyBenefits: metafield(key: "key_benefits", namespace: "custom") { value }
                                  shortDescription: metafield(key: "short_description", namespace: "custom") { value }
                                  howToVideo: metafield(key: "watch_a_how_to_video", namespace: "custom") {
                                    reference {
                                      ... on Video {
                                        previewImage { url }
                                        sources { url mimeType }
                                      }
                                    }
                                  }
                                  variants(first: 10) { # Fetch up to 10 variants
                                    edges {
                                      node {
                                        id
                                        title
                                        sku
                                        price {
                                          amount
                                          currencyCode
                                        }
                                        image { url altText }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                `;

                try {
                    const response = await fetch(`${this.storeUrl}/api/2026-04/graphql.json`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Shopify-Storefront-Access-Token": this.storefrontToken,
                        },
                        body: JSON.stringify({ query }),
                    });
                    const result = await response.json();
                    if (result.errors) {
                        console.error("GraphQL Errors fetching product meta:", result.errors);
                        this.apiError = true;
                        hasNextPage = false;
                    } else {
                        allProductMeta = allProductMeta.concat(result.data.metaobjects.edges);
                        hasNextPage = result.data.metaobjects.pageInfo.hasNextPage;
                        cursor = result.data.metaobjects.pageInfo.endCursor;
                    }
                } catch (error) {
                    console.error("Error fetching quiz product meta:", error);
                    this.apiError = true;
                    hasNextPage = false;
                }
            }

            // Store all parsed products in a flat array for easier searching of non-ritual products
            this.rawAllProducts = allProductMeta.map(({ node: meta }) => {
                const product = meta.product?.reference;
                if (!product) return null; // Skip if no product reference

                return {
                    ...product,
                    descriptor: product.descriptor?.value,
                    keyBenefits: product.keyBenefits ? JSON.parse(product.keyBenefits.value) : [],
                    shortDescription: product.shortDescription?.value,
                    howToVideoSources: product.howToVideo?.reference?.sources || [],
                    howToVideoPoster: product.howToVideo?.reference?.previewImage?.url || '',
                    variants: product.variants?.edges.map(edge => edge.node) || [],
                    meta: {
                        ritual_step: meta.ritual_step?.value,
                        double_cleanse_step: meta.double_cleanse_step?.value,
                        carousel: meta.carousel?.value === 'true',
                        carousel_category: meta.carousel_category?.value,
                        carousel_excl_layering: meta.carousel_excl_layering?.value,
                        am_pm: meta.am_pm?.value,
                        product_lines: meta.product_lines?.value ? JSON.parse(meta.product_lines.value) : []
                    }
                };
            }).filter(Boolean); // Filter out any null entries
            // console.log('All raw quiz products:', this.rawAllProducts);

            const groupedProducts = {};
            allProductMeta.forEach(({ node: meta }) => {
                const product = meta.product?.reference;
                const ritualStep = meta.ritual_step?.value;

                if (product && ritualStep) {
                    if (!groupedProducts[ritualStep]) {
                        groupedProducts[ritualStep] = [];
                    }
                    const fullProductData = {
                        ...product,
                        descriptor: product.descriptor?.value,
                        keyBenefits: product.keyBenefits ? JSON.parse(product.keyBenefits.value) : [],
                        shortDescription: product.shortDescription?.value,
                        howToVideoSources: product.howToVideo?.reference?.sources || [],
                        howToVideoPoster: product.howToVideo?.reference?.previewImage?.url || '',
                        variants: product.variants?.edges.map(edge => edge.node) || [],
                        meta: {
                            ritual_step: ritualStep,
                            double_cleanse_step: meta.double_cleanse_step?.value,
                            carousel: meta.carousel?.value === 'true',
                            carousel_category: meta.carousel_category?.value,
                            am_pm: meta.am_pm?.value,
                            product_lines: meta.product_lines?.value ? JSON.parse(meta.product_lines.value) : []
                        }
                    };
                    groupedProducts[ritualStep].push(fullProductData);
                }
            });

            this.allProducts = groupedProducts;
            console.log('Product buckets by ritual step:', Object.fromEntries(
                Object.entries(this.allProducts).map(([step, products]) => [
                    step,
                    products.map(p => {
                        const sku = p.variants[0]?.sku;
                        return sku ? `(${sku}) ${p.title}` : p.title;
                    })
                ])
            ));
        },
        fetchSunscreenProduct() {
            const targetProductId = "gid://shopify/Product/8941272072343"; // The product ID for SKU "JSUQ"
            let foundProduct = null;            

            if (this.rawAllProducts && this.rawAllProducts.length > 0) {
                foundProduct = this.rawAllProducts.find(p => p.id === targetProductId);
                if (foundProduct) {
                    this.sunscreenProduct = foundProduct;
                    // console.log('Sunscreen product found from rawAllProducts:', this.sunscreenProduct);
                }
            }
            if (!this.sunscreenProduct) {
                console.warn(`Sunscreen product with ID ${targetProductId} not found in fetched products.`);
            }
        },
        formatPrice(amount, currencyCode) {
            if (!amount || !currencyCode) return '';
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(amount);
        },
        getCurrentStep() {
            return this.currentStep;
        },

        setCurrentStep(step) {
            this.currentStep = step;
            this.subtitleLimitWarning = false;
            if (this.currentStep !== 3) {
                this.closeInfoOverlay();
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },

        scrollInterstitialIntoView() {
            const el = document.querySelector('.dsk-quiz-interstitial-wrapper');
            if (!el) return;
            const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
            const top = el.getBoundingClientRect().top + window.scrollY - headerHeight;
            window.scrollTo({ top, behavior: 'smooth' });
        },

        isSingleSelectType(type) {
            return !type ||
                type === this.question_types.SINGLE_1_COL ||
                type === this.question_types.SINGLE_IMG_1_ROW ||
                type === this.question_types.SINGLE_HEADER_IMG_2_COL ||
                type === this.question_types.SINGLE_ICONS ||
                type === this.question_types.SINGLE_IMG_2_COL;
        },

        getCurrentQuestion() {
            return this.questions.find(q => q.step === this.currentStep);
        },

        validateStep() {
            const currentQuestion = this.getCurrentQuestion();
            if (!currentQuestion) {
                return true;
            }

            if (this.isSingleSelectType(currentQuestion.type)) {
                const answer = this.answers['step' + this.currentStep];
                if (!answer) {
                    this.errorMessage = 'Please select an option before proceeding.';
                    return false;
                }
            } else if (currentQuestion.type === this.question_types.MULTIPLE_2_COL || currentQuestion.type === this.question_types.MULTIPLE_ICONS_1_ROW || currentQuestion.type === this.question_types.MULTIPLE_IMG_2_COL) {
                const answer = this.answers['step' + this.currentStep];
                if (currentQuestion.step === 5 && currentQuestion.limit) {
                    if (!answer || answer.length !== currentQuestion.limit) {
                        this.errorMessage = `Please select ${currentQuestion.limit} options.`;
                        return false;
                    }
                } else {
                    if (!answer || answer.length === 0) {
                        this.errorMessage = 'Please select at least one option before proceeding.';
                        return false;
                    }
                }
            }
            this.errorMessage = '';
            return true;
        },

        isMultipleChoiceContinueDisabled() {
            const question = this.getCurrentQuestion();
            if (!question) return true;

            const stepAnswers = this.answers['step' + this.currentStep];

            // Special validation for step 5
            if (question.step === 5 && question.limit) {
                return !stepAnswers || stepAnswers.length !== question.limit;
            }

            // Default validation for other multiple choice questions
            return !stepAnswers || stepAnswers.length === 0;
        },

        handleNavClick(direction) {
            if (direction === 'next') {
                // Validate current step first
                if (!this.validateStep()) return;

                if (this.getCurrentStep() === this.questions.length) {
                    this.getRitualProducts();
                    this.debugFetchAllLogicRules();
                    return;
                }

                // If we're advancing from step 4 or 6, open the interstitial first
                if ((this.getCurrentStep() === 4 || this.getCurrentStep() === 6) && !this.interstitialOpen) {
                    this.interstitialOpen = true;
                    if (window.matchMedia('(max-width: 768px)').matches) {
                        this.$nextTick(() => this.scrollInterstitialIntoView());
                    } else {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                    // Set custom interstitial HTML based on the selected answer for step 4 or 6
                    const currentAnswer = this.answers['step' + this.currentStep];
                    if (currentAnswer && currentAnswer.tag) {
                        const currentQuestion = this.getCurrentQuestion();
                        const selectedOption = currentQuestion.options.find(opt => opt.shopTag === currentAnswer.tag);
                        this.currentInterstitialHtml = selectedOption ? selectedOption.interstitialHtml : '';

                        if (this.getCurrentStep() === 6) {
                            const tag = currentAnswer.tag;
                            if (tag === 'dsk-quiz-layering-yes' || tag === 'dsk-quiz-layering-one') {
                                this.interstitialOptionGroup = '1-2';
                            } else if (tag === 'dsk-quiz-layering-familiar' || tag === 'dsk-quiz-layering-new') {
                                this.interstitialOptionGroup = '3-4';
                            }
                        }
                    }
                    return;
                }

                this.setCurrentStep(Math.min(this.questions.length, this.getCurrentStep() + 1));
            } else if (direction === 'prev') {
                if (this.preResultsVisible) {
                    this.preResultsVisible = false;
                    return;
                }
                // Closing interstitial if open when navigating back
                if (this.interstitialOpen) {
                    this.interstitialOpen = false;
                    this.currentInterstitialHtml = ''; // Clear interstitial content on close
                    this.interstitialOptionGroup = '';
                    return;
                }
                this.setCurrentStep(Math.max(0, this.getCurrentStep() - 1));
            }
            // Reset limitReached when navigating
            this.limitReached = false;
        },
        setAnswer(shopTag, optionName, optionDesc) {
            const description = optionDesc ?  ` - ${optionDesc}` : '';
            const step = this.getCurrentStep();
            this.answers['step' + step] = {'tag': shopTag, 'text': `${optionName}${description}`};
            this.errorMessage = '';
            this.subtitleLimitWarning = false;
        },

        setAnswerAndNext(shopTag, optionName, optionDesc) {
            this.setAnswer(shopTag, optionName, optionDesc);
            const currentQuestion = this.getCurrentQuestion();
            if (!currentQuestion || this.isSingleSelectType(currentQuestion.type)) {
                this.handleNavClick('next');
            }
        },
        openInfoOverlay() {
            this.infoOverlayOpen = true;
        },

        closeInfoOverlay() {
            this.infoOverlayOpen = false;
        },
        setAnswerMultiple(shopTag, optionName, optionDesc) {
            const answerText = optionName + (optionDesc ?  ` - ${optionDesc}` : '');
            const step = this.getCurrentStep();
            const currentQuestion = this.getCurrentQuestion();
            const limit = currentQuestion.limit || Infinity;
            const stepKey = 'step' + step;

            const existingAnswers = this.answers[stepKey] || [];
            const sameAnswerIndex = existingAnswers.findIndex(answer => answer.tag == shopTag);

            if (sameAnswerIndex !== -1) {
                existingAnswers.splice(sameAnswerIndex, 1);
                this.subtitleLimitWarning = false;
                this.errorMessage = '';
            } else {
                if (existingAnswers.length >= limit) {
                    return; // Prevent selection if limit is reached
                }
                if (this.answers[stepKey]) {
                    this.answers[stepKey].push({'tag': shopTag, 'text': answerText });
                } else {
                    this.answers[stepKey] = [{'tag': shopTag, 'text': answerText }];
                }
                this.subtitleLimitWarning = false;
                this.errorMessage = '';
            }

            // Update limitReached state after modification
            this.limitReached = (this.answers[stepKey] || []).length >= limit;
        },
        proceedFromInterstitial() {
            this.interstitialOpen = false;
            this.setCurrentStep(Math.min(this.questions.length, this.getCurrentStep() + 1));
            this.currentInterstitialHtml = ''; // Clear interstitial content after proceeding
            this.interstitialOptionGroup = '';
        },
        // Serializes a built ritual into a flat, Klaviyo-template-friendly array:
        // one entry per displayed product card (double cleanse contributes two),
        // skipping "No Matching Product" placeholders.
        _buildRitualPayload(routine) {
            const payload = [];
            (this.ritualStepGroups[routine] || []).forEach(group => {
                group.products.forEach(product => {
                    if (!product || product.isEmpty) return;
                    // Mirror the card: user's dropdown selection if changed, else default first variant
                    const variantId = this.selectedVariantIds[product.id] || product.variants?.[0]?.id;
                    const variant = product.variants?.find(v => v.id === variantId) || product.variants?.[0];
                    const amount = variant?.price?.amount || product.priceRange?.minVariantPrice?.amount || '';
                    const currency = variant?.price?.currencyCode || product.priceRange?.minVariantPrice?.currencyCode || '';
                    payload.push({
                        "Step": group.stepNumber,
                        "StepLabel": group.label,
                        "Title": product.title || '',
                        "ShortDescription": product.shortDescription || '',
                        "VariantTitle": variant?.title || '',
                        "Price": this.formatPrice(amount, currency),
                        "PriceAmount": amount,
                        "Currency": currency,
                        "Image": variant?.image?.url || product.featuredImage?.url || '',
                        "Url": product.handle ? `${this.storeUrl}/products/${product.handle}` : ''
                    });
                });
            });
            return payload;
        },
        // Serializes the user's answers into a flat, Klaviyo-template-friendly
        // array in quiz order: one { Question, Answer } entry per answered
        // question (multi-selects joined with "; "), skipping unanswered steps.
        _buildAnswersPayload() {
            return this.questions.map((question, index) => {
                const answer = this.answers['step' + (index + 1)];
                if (!answer) return null;
                const text = Array.isArray(answer)
                    ? answer.map(a => a.text).join('; ')
                    : answer.text;
                if (!text) return null;
                return { "Question": question.text, "Answer": text };
            }).filter(Boolean);
        },
        async emailResults() {
            // push([...]) queues safely even if klaviyo.js hasn't loaded yet,
            // unlike calling .identify()/.track() directly on the stub array.
            window.klaviyo = window.klaviyo || [];

            // Identify the logged-in Shopify customer (email passed via data attribute
            // in the section template). Guests are identified by the Klaviyo signup
            // form on the pre-results view instead.
            if (this.customerEmail) {
                window.klaviyo.push(['identify', {
                    "$email": this.customerEmail
                }]);
            }

            window.klaviyo.push(['track', "Decorte Quiz Results", {
                "Timestamp": new Date().toISOString(),
                "Results": this.answers,
                "Quiz Answers": this._buildAnswersPayload(),
                "AM Ritual": this._buildRitualPayload('AM'),
                "PM Ritual": this._buildRitualPayload('PM'),
                "Ritual Collection": this.ritualCollection
            }]);
        },
        // Fires the Klaviyo event that awards 25 Yotpo points for completing the
        // quiz (a Klaviyo flow listens for this metric and webhooks Yotpo — see
        // the comment on yotpoRewardSent above). Fires at most once per page load,
        // and only for an identifiable customer: a logged-in Shopify customer
        // (default email from the section's data attribute) or a shopper who just
        // signed up on the pre-results form (email passed in from the form's
        // submit event; even without it, klaviyo.js has already identified the
        // browser by that point). Anonymous guests get nothing — an unidentified
        // event would reach the flow with no email to send Yotpo.
        triggerQuizCompletionReward(email = this.customerEmail) {
            const identifyPayload = email ? { '$email': email } : null;
            const trackPayload = [this.YOTPO_QUIZ_METRIC, { source: 'dsk-quiz' }];
            console.log('[DSK Quiz Yotpo reward] triggerQuizCompletionReward called', {
                resolvedEmail: email || '(empty)',
                customerEmail: this.customerEmail || '(empty)',
                isLoggedIn: this.isLoggedIn,
                signupComplete: this.signupComplete,
                yotpoRewardSentAlready: this.yotpoRewardSent,
                willIdentify: !!identifyPayload,
                identifyPayload,
                trackPayload,
            });
            if (!email && !this.signupComplete) {
                console.warn('[DSK Quiz Yotpo reward] SKIPPED — no email and not a completed signup (anonymous guest). Nothing sent to Klaviyo, so the flow (and Yotpo) will never fire for this visitor.');
                return; // anonymous guest → perform no action
            }
            if (this.yotpoRewardSent) {
                console.warn('[DSK Quiz Yotpo reward] SKIPPED — already sent once this page load.');
                return;
            }
            this.yotpoRewardSent = true;
            // push([...]) queues safely even if klaviyo.js hasn't loaded yet.
            window.klaviyo = window.klaviyo || [];
            if (identifyPayload) {
                window.klaviyo.push(['identify', identifyPayload]);
            } else {
                console.warn('[DSK Quiz Yotpo reward] No email to identify with — the track event will land on whatever profile klaviyo.js currently holds (from the __kla_id cookie / prior form submit). If that profile has no email, {{ person.email }} in the Klaviyo webhook will be blank and Yotpo will reject the call.');
            }
            window.klaviyo.push(['track', this.YOTPO_QUIZ_METRIC, { source: 'dsk-quiz' }]);
            console.log('[DSK Quiz Yotpo reward] Pushed identify + track to window.klaviyo. Check the Network tab for the request to a.klaviyo.com (filter: klaviyo) to see the exact payload Klaviyo received.');
        },
       productMatchesRules(product, routine) {
            const productRuleData = this.quizLogicRules[product.id];
            if (!productRuleData || !productRuleData.rules || productRuleData.rules.length === 0) {
                return false;
            }

            const amPm = product.meta?.am_pm?.toLowerCase();
            if (routine && routine.toLowerCase() === 'am' && amPm === 'pm') return false;
            if (routine && routine.toLowerCase() === 'pm' && amPm === 'am') return false;

            // Every rule must be satisfied (AND logic across rules)
            return productRuleData.rules.every(rule => {
                const userAnswer = this.answers['step' + rule.questionId];
                if (!userAnswer) return false;

                const eligibleAnswerTags = rule.eligibleAnswers.map(ea => ea.answer);
                if (Array.isArray(userAnswer)) {
                    return userAnswer.map(a => a.tag).some(tag => eligibleAnswerTags.includes(tag));
                }
                return eligibleAnswerTags.includes(userAnswer.tag);
            });
        },
        _scoreProduct(product, routine, applyKnockouts = false) {
            // Single source of truth for scoring lives in _getScoreBreakdown.
            return this._getScoreBreakdown(product, routine, applyKnockouts).score;
        },
        _getScoreBreakdown(product, routine, applyKnockouts = false) {
            const amPm = product.meta?.am_pm?.toLowerCase();
            if (routine && routine.toLowerCase() === 'am' && amPm === 'pm') return { score: -1, detail: '  excluded: PM-only' };
            if (routine && routine.toLowerCase() === 'pm' && amPm === 'am') return { score: -1, detail: '  excluded: AM-only' };

            const productRuleData = this.quizLogicRules[product.id];
            if (!productRuleData?.rules?.length) return { score: 0, detail: '  no rules → score 0' };

            if (applyKnockouts) {
                for (const rule of productRuleData.rules) {
                    if (!KNOCKOUT_QUESTIONS.has(Number(rule.questionId))) continue;
                    const userAnswer = this.answers['step' + rule.questionId];
                    if (!userAnswer) continue;
                    const eligible = rule.eligibleAnswers.map(ea => ea.answer);
                    const matched = Array.isArray(userAnswer)
                        ? userAnswer.some(a => eligible.includes(a.tag))
                        : eligible.includes(userAnswer.tag);
                    if (!matched) return { score: -1, detail: `  excluded: no match on knockout Q${rule.questionId}` };
                }
            }

            const pointsMode = SCORING_MODE === 'points';

            let matched = 0;
            const ruleLines = productRuleData.rules.map(rule => {
                const userAnswer = this.answers['step' + rule.questionId];
                if (!userAnswer) return `  Q${rule.questionId}: no answer`;
                const eligible = rule.eligibleAnswers.map(ea => ea.answer);
                // In 'points' mode, boost step-2 (skincare concerns) so it counts double.
                const weight = pointsMode ? (QUESTION_WEIGHTS[Number(rule.questionId)] ?? 1) : 1;
                if (Array.isArray(userAnswer)) {
                    const hits = userAnswer.filter(a => eligible.includes(a.tag));
                    if (hits.length > 0) {
                        // 'points': 1 point per matching answer (× weight).
                        // 'fractional': original fractional credit across selected answers.
                        matched += pointsMode ? hits.length * weight : hits.length / userAnswer.length;
                    }
                    return `  Q${rule.questionId}: ${hits.length > 0 ? '[Y]' : '[N]'} (${hits.length}/${userAnswer.length} answers matched${pointsMode && weight !== 1 ? `, ×${weight}` : ''})`;
                } else {
                    const hit = eligible.includes(userAnswer.tag);
                    if (hit) matched += pointsMode ? weight : 1;
                    return `  Q${rule.questionId}: ${hit ? '[Y]' : '[N]'} (user: ${userAnswer.tag})`;
                }
            });

            // Moisturize-specific bonus: Q2 concern → product line affinity (+1 per matching rule)
            if (product.meta?.ritual_step === 'Moisturize') {
                const q2Answers = this.answers['step2'] || [];
                const productLines = (product.meta?.product_lines || []).map(l => l.toLowerCase());
                const sku = product.variants?.[0]?.sku || '?';
                MOISTURIZE_CONCERNS.forEach(({ concern, line }) => {
                    if (q2Answers.some(a => a.tag === concern) && productLines.includes(line)) {
                        matched += 1;
                        console.log(`[Moisturize bonus] +1 for (${sku}) ${product.title}: Q2 "${concern}" matches line "${line}"`);
                        ruleLines.push(`  [Moisturize bonus] +1: Q2 "${concern}" → line "${line}"`);
                    }
                });
            }

            // 'points' returns the raw point total; 'fractional' normalizes by rule count.
            const score = pointsMode ? matched : matched / productRuleData.rules.length;
            return { score, detail: ruleLines.join('\n') };
        },
        // Returns every product sharing the top score (the "tie set"), excluding
        // AM/PM-excluded products (score < 0). Used to reconcile the Lotion/Emulsion
        // pair so a tie on one side never produces a cross-line pairing.
        _getTopScorers(candidates, routine) {
            const EPSILON = 1e-9;
            const seen = new Set();
            const scored = candidates
                .filter(p => {
                    if (seen.has(p.id)) return false;
                    seen.add(p.id);
                    return true;
                })
                .map(p => ({ product: p, score: this._getScoreBreakdown(p, routine, true).score }))
                .filter(({ score }) => score >= 0);
            if (!scored.length) return { tied: [], bestScore: -1 };
            const bestScore = scored.reduce((max, { score }) => Math.max(max, score), -Infinity);
            const tied = scored
                .filter(({ score }) => Math.abs(score - bestScore) < EPSILON)
                .map(({ product }) => product);
            return { tied, bestScore };
        },
        findMatchingProducts(ritualStep, routine) {
            const productsInStep = this.allProducts[ritualStep] || [];
            if (!productsInStep.length) {
                console.warn(`No products found for ritual step: ${ritualStep}`);
                return [];
            }

            // Repair step always uses Liposome Advanced Repair Serum (SKU: JVAN)
            if (ritualStep === 'Repair') {
                const repairProduct = productsInStep.find(p =>
                    p.variants?.some(v => v.sku === 'JVAN')
                );
                console.log(`[Ritual ${routine}] Repair: hardcoded JVAN → ${repairProduct ? repairProduct.title : `not found, falling back to ${productsInStep[0]?.title}`}`);
                if (repairProduct) {
                    // Put the JVAN variant first so the UI defaults to it (selectedVariantId = variants[0].id)
                    const jvanIdx = repairProduct.variants.findIndex(v => v.sku === 'JVAN');
                    if (jvanIdx > 0) {
                        const reordered = [...repairProduct.variants];
                        const [jvan] = reordered.splice(jvanIdx, 1);
                        reordered.unshift(jvan);
                        return [{ ...repairProduct, variants: reordered }];
                    }
                    return [repairProduct];
                }
                return [productsInStep[0]];
            }

            // Condition step: behaviour depends on layering answer
            if (ritualStep === 'Condition') {
                const layeringAnswer = this.answers?.step6?.tag;
                if (layeringAnswer === 'dsk-quiz-layering-familiar' || layeringAnswer === 'dsk-quiz-layering-new') {
                    // 5-step path: always use JVXC (YPAE all-in-one essence)
                    const jvxc = this.rawAllProducts.find(p => p.variants?.some(v => v.sku === 'JVXC'));
                    console.log(`[Ritual ${routine}] Condition (5-step): hardcoded JVXC → ${jvxc ? `(JVXC) ${jvxc.title}` : 'NOT FOUND in rawAllProducts'}`);
                    if (jvxc) return [jvxc];
                } else if (layeringAnswer === 'dsk-quiz-layering-yes' || layeringAnswer === 'dsk-quiz-layering-one') {
                    // 6-step path: exclude JVXC so scoring always returns a true emulsion
                    const seen = new Set();
                    const candidates = productsInStep.filter(p => {
                        if (seen.has(p.id)) return false;
                        seen.add(p.id);
                        return !p.variants?.some(v => v.sku === 'JVXC');
                    });
                    console.log(`[Ritual ${routine}] Condition (6-step): ${candidates.length} candidate(s) after excluding JVXC`);
                    // fall through to standard scoring below using filtered candidates
                    let bestProduct = null, bestScore = -1;
                    const scoreLog = [];
                    candidates.forEach(product => {
                        const { score, detail } = this._getScoreBreakdown(product, routine, true);
                        const sku = product.variants[0]?.sku || '?';
                        scoreLog.push({ product, sku, score, detail });
                        if (score > bestScore) { bestScore = score; bestProduct = product; }
                    });
                    console.group(`[Ritual ${routine}] Condition (6-step) — ${scoreLog.length} candidate(s)`);
                    scoreLog.forEach(({ product, sku, score, detail }) => {
                        const selected = product === bestProduct && bestScore >= 0;
                        console.log(`${selected ? '★ SELECTED  ' : '            '}(${sku}) ${product.title}  →  ${score === -1 ? 'excluded' : 'score ' + score.toFixed(3)}\n${detail}`);
                    });
                    if (!bestProduct || bestScore < 0) {
                        console.warn('  No qualifying product found with knockouts — falling back to highest score');
                        candidates.forEach(product => {
                            const { score } = this._getScoreBreakdown(product, routine, false);
                            if (score > bestScore) { bestScore = score; bestProduct = product; }
                        });
                        if (bestProduct && bestScore >= 0) {
                            console.log(`  Fallback selected: (${bestProduct.variants[0]?.sku || '?'}) ${bestProduct.title}`);
                        } else {
                            console.warn('  Fallback also found no qualifying product');
                        }
                    }
                    console.groupEnd();
                    return bestProduct !== null && bestScore >= 0 ? [bestProduct] : [];
                }
            }

            // Deduplicate products by ID before scoring
            const seen = new Set();
            const uniqueProducts = productsInStep.filter(p => {
                if (seen.has(p.id)) return false;
                seen.add(p.id);
                return true;
            });

            // Score each product: (rules matched / total rules), -1 if AM/PM excluded
            // Cleanse is excluded from knockout filtering — all products would be knocked out otherwise.
            const applyKnockouts = ritualStep !== 'Cleanse';
            let bestProduct = null;
            let bestScore = -1;
            const scoreLog = [];
            uniqueProducts.forEach(product => {
                const { score, detail } = this._getScoreBreakdown(product, routine, applyKnockouts);
                const sku = product.variants[0]?.sku || '?';
                scoreLog.push({ product, sku, score, detail });
                if (score > bestScore) {
                    bestScore = score;
                    bestProduct = product;
                }
            });

            console.group(`[Ritual ${routine}] ${ritualStep} — ${scoreLog.length} candidate(s)`);
            scoreLog.forEach(({ product, sku, score, detail }) => {
                const selected = product === bestProduct && bestScore >= 0;
                console.log(`${selected ? '★ SELECTED  ' : '            '}(${sku}) ${product.title}  →  ${score === -1 ? 'excluded' : 'score ' + score.toFixed(3)}\n${detail}`);
            });
            if (!bestProduct || bestScore < 0) {
                if (ritualStep === 'Hydrate' || ritualStep === 'Moisturize' || ritualStep === 'Eye Care') {
                    console.warn('  No qualifying product found with knockouts — falling back to highest score');
                    uniqueProducts.forEach(product => {
                        const { score } = this._getScoreBreakdown(product, routine, false);
                        if (score > bestScore) { bestScore = score; bestProduct = product; }
                    });
                    if (bestProduct && bestScore >= 0) {
                        console.log(`  Fallback selected: (${bestProduct.variants[0]?.sku || '?'}) ${bestProduct.title}`);
                    } else {
                        console.warn('  Fallback also found no qualifying product');
                    }
                } else {
                    console.warn('  No qualifying product found');
                }
            }
            console.groupEnd();

            return bestProduct !== null && bestScore >= 0 ? [bestProduct] : [];
        },
        findDoubleCleanseProducts(routine) {
            const cleanseProducts = this.allProducts['Cleanse'] || [];
            if (!cleanseProducts.length) return [];

            // Group by double_cleanse_step value (e.g. "1", "2")
            const byStep = {};
            cleanseProducts.forEach(p => {
                const ds = p.meta?.double_cleanse_step;
                if (ds) {
                    if (!byStep[ds]) byStep[ds] = [];
                    byStep[ds].push(p);
                }
            });

            const findBest = (candidates, stepLabel) => {
                if (!candidates || !candidates.length) return null;
                const seen = new Set();
                const unique = candidates.filter(p => {
                    if (seen.has(p.id)) return false;
                    seen.add(p.id);
                    return true;
                });
                let best = null, bestScore = -1;
                const scoreLog = [];
                unique.forEach(p => {
                    const { score, detail } = this._getScoreBreakdown(p, routine, false);
                    const sku = p.variants[0]?.sku || '?';
                    scoreLog.push({ p, sku, score, detail });
                    if (score > bestScore) { bestScore = score; best = p; }
                });
                console.group(`[Ritual ${routine}] Double Cleanse ${stepLabel} — ${scoreLog.length} candidate(s)`);
                scoreLog.forEach(({ p, sku, score, detail }) => {
                    const selected = p === best && bestScore >= 0;
                    console.log(`${selected ? '★ SELECTED  ' : '            '}(${sku}) ${p.title}  →  ${score === -1 ? 'excluded' : 'score ' + score.toFixed(3)}\n${detail}`);
                });
                if (!best || bestScore < 0) console.warn('  No qualifying product found');
                console.groupEnd();
                return bestScore >= 0 ? best : null;
            };

            const stepKeys = Object.keys(byStep).sort((a, b) => parseInt(a) - parseInt(b));
            const results = [];
            stepKeys.forEach(key => {
                const best = findBest(byStep[key], `step-${key}`);
                if (best) results.push(best);
            });

            // Fallback: if no double_cleanse_step metadata, return best 2 cleanse products
            if (results.length === 0) {
                const seen = new Set();
                const unique = cleanseProducts.filter(p => {
                    if (seen.has(p.id)) return false;
                    seen.add(p.id);
                    return true;
                });
                return unique
                    .map(p => ({ p, score: this._scoreProduct(p, routine, false) }))
                    .filter(({ score }) => score >= 0)
                    .sort((a, b) => b.score - a.score)
                    .slice(0, 2)
                    .map(({ p }) => p);
            }
            return results;
        },
        getRitualStep1(routine) {
            return this.findMatchingProducts('Cleanse', routine);
        },
        getRitualStep2(routine) {
            return this.findMatchingProducts('Repair', routine);
        },
        getRitualStep3(routine) {
            return this.findMatchingProducts('Moisturize', routine);
        },
        getRitualStep4(routine) {
            return this.findMatchingProducts('Eye Care', routine);
        },
        buildRitual(routine = 'AM', size = 'small') {
            let stepSequence;
            if (size === 'large-6') {
                stepSequence = ['Cleanse', 'Repair', 'Condition', 'Hydrate', 'Moisturize', 'Eye Care'];
            } else if (size === 'large-5') {
                stepSequence = ['Cleanse', 'Repair', 'Condition', 'Moisturize', 'Eye Care'];
            } else {
                stepSequence = ['Cleanse', 'Repair', 'Moisturize', 'Eye Care'];
            }

            this.resultStepLabels = stepSequence;
            const isDoubleCleanseRoutine = routine === 'PM';

            const makePlaceholder = (key) => ({
                id: `placeholder-${routine}-${key}`,
                isEmpty: true,
                title: 'No Matching Product',
                descriptor: 'A suitable product could not be found for this step.',
                featuredImage: { url: '', altText: 'No product found' },
                priceRange: { minVariantPrice: { amount: '0.00', currencyCode: 'USD' } },
                keyBenefits: [],
                shortDescription: '',
                variants: [],
                meta: {}
            });

            const stepGroups = [];
            let stepNumber = 1;

            stepSequence.forEach(stepKey => {
                if (stepKey === 'Cleanse' && isDoubleCleanseRoutine) {
                    const dcProducts = this.findDoubleCleanseProducts(routine);
                    const p1 = dcProducts[0] || makePlaceholder('cleanse-1');
                    const p2 = dcProducts[1] || makePlaceholder('cleanse-2');
                    stepGroups.push({
                        id: 'double-cleanse',
                        stepNumber,
                        label: 'Double Cleanse',
                        isDouble: true,
                        products: [p1, p2]
                    });
                } else {
                    let displayLabel = stepKey;
                    if (stepKey === 'Hydrate' && isDoubleCleanseRoutine) displayLabel = 'Hydrate/Prep';
                    const matched = this.findMatchingProducts(stepKey, routine);
                    const product = matched.length > 0 ? matched[0] : makePlaceholder(stepKey);
                    stepGroups.push({
                        id: stepKey.toLowerCase().replace(/\s+/g, '-'),
                        stepNumber,
                        label: displayLabel,
                        isDouble: false,
                        products: [product]
                    });
                }
                stepNumber++;
            });

            this.ritualStepGroups[routine] = stepGroups;

            // Reconcile the Lotion (Hydrate) + Emulsion (Condition) pair so they always
            // share a product line. Only the 6-step ritual has both slots (Q6 = layering
            // yes/one); all other paths are unaffected.
            if (size === 'large-6') {
                this._reconcileLayeringPair(routine, stepGroups);
            }

            // Break ties in the Moisturize slot using Q2 concern → product line mapping.
            // Runs after layering reconciliation; AM and PM are handled independently.
            this._reconcileMoisturizeTie(routine, stepGroups);

            // For 6-step: pull Lotion/Emulsion toward the Moisturize product's collection
            // while preserving their pairwise consistency.
            if (size === 'large-6') {
                this._reconcileLayeringToMoisturize(routine, stepGroups);
            }

            const moisturizeGroup = stepGroups.find(g => g.label === 'Moisturize');
            const moisturizeProduct = moisturizeGroup?.products[0];
            const productLine = moisturizeProduct?.meta?.product_lines?.[0];
            if (!productLine) {
                console.warn(`[Ritual ${routine}] No product_lines assigned to Moisturize product: ${moisturizeProduct?.title || 'unknown'}`);
            }
            this.ritualCollection[routine] = productLine || null;

            // Flat array for getProductAmPmBadges lookups (backward compat)
            const flatRitual = [];
            stepGroups.forEach(g => g.products.forEach(p => flatRitual.push(p)));
            this.ritualProducts[routine] = flatRitual;

            // Debug
            const clGrp = stepGroups.find(g => g.label === 'Cleanse' || g.label === 'Double Cleanse');
            const trGrp = stepGroups.find(g => g.label === 'Repair');
            const s3Grp = stepGroups.find(g => ['Condition', 'Moisturize'].includes(g.label));
            const eyGrp = stepGroups.find(g => g.label === 'Eye Care');
            this.debug.step1 = clGrp?.products || [];
            this.debug.step2 = trGrp?.products || [];
            this.debug.step3 = s3Grp?.products || [];
            this.debug.step4 = eyGrp?.products || [];
        },
        // Ensures the Lotion (Hydrate step) and Emulsion (Condition step) come from the
        // same product line. When one side has a scoring tie and the other is a single
        // winner, re-pick the tied side to the candidate whose line matches the single
        // winner. If both sides tie (or neither does), the selection is left untouched.
        // Edge case: when all candidates in both pools are knocked out by Q2/Q3, runs a
        // no-knockout fallback that first tries the PM Moisturize product's line, then
        // falls back to the highest no-knockout scorer's line.
        _reconcileLayeringPair(routine, stepGroups) {
            const lotionGroup = stepGroups.find(g => g.label === 'Hydrate' || g.label === 'Hydrate/Prep');
            const emulsionGroup = stepGroups.find(g => g.label === 'Condition');
            if (!lotionGroup || !emulsionGroup) return;

            const chosenLotion = lotionGroup.products[0];
            const chosenEmulsion = emulsionGroup.products[0];
            if (!chosenLotion || chosenLotion.isEmpty || !chosenEmulsion || chosenEmulsion.isEmpty) return;

            // Tie sets, mirroring how each slot is scored in findMatchingProducts.
            const lotionTie = this._getTopScorers(this.allProducts['Hydrate'] || [], routine).tied;
            const emulsionTie = this._getTopScorers(
                (this.allProducts['Condition'] || []).filter(p => !p.variants?.some(v => v.sku === 'JVXC')),
                routine
            ).tied;

            const lineOf = (p) => p?.meta?.product_lines || [];
            const sameLine = (a, b) => lineOf(a).some(line => lineOf(b).includes(line));
            const sku = (p) => p?.variants?.[0]?.sku || '?';

            const lotionTied = lotionTie.length > 1;
            const emulsionTied = emulsionTie.length > 1;

            console.group(`[Ritual ${routine}] Layering pair reconciliation`);
            console.log(`  Lotion (Hydrate):  (${sku(chosenLotion)}) ${chosenLotion.title} — tie set: ${lotionTie.map(sku).join(', ') || 'none'}`);
            console.log(`  Emulsion (Condition): (${sku(chosenEmulsion)}) ${chosenEmulsion.title} — tie set: ${emulsionTie.map(sku).join(', ') || 'none'}`);

            if (lotionTied && emulsionTied) {
                console.log('  Both sides tied → out of scope, no change.');
            } else if (lotionTied && !emulsionTied) {
                // Rule 1: keep the lotion whose line matches the single emulsion.
                if (sameLine(chosenLotion, chosenEmulsion)) {
                    console.log('  Rule 1: chosen lotion already matches emulsion line → no change.');
                } else {
                    const match = lotionTie.find(p => sameLine(p, chosenEmulsion));
                    if (match) {
                        lotionGroup.products = [match];
                        console.log(`  Rule 1: swapped lotion → (${sku(match)}) ${match.title} to match emulsion line.`);
                    } else {
                        console.warn('  Rule 1: no tied lotion matches emulsion line → leaving selection unchanged.');
                    }
                }
            } else if (emulsionTied && !lotionTied) {
                // Rule 2: keep the emulsion whose line matches the single lotion.
                if (sameLine(chosenEmulsion, chosenLotion)) {
                    console.log('  Rule 2: chosen emulsion already matches lotion line → no change.');
                } else {
                    const match = emulsionTie.find(p => sameLine(p, chosenLotion));
                    if (match) {
                        emulsionGroup.products = [match];
                        console.log(`  Rule 2: swapped emulsion → (${sku(match)}) ${match.title} to match lotion line.`);
                    } else {
                        console.warn('  Rule 2: no tied emulsion matches lotion line → leaving selection unchanged.');
                    }
                }
            } else {
                if (lotionTie.length === 0 && emulsionTie.length === 0) {
                    // All candidates in both pools were knocked out (e.g. Q2 concern not matched by
                    // any lotion/emulsion rule). findMatchingProducts already set each group
                    // independently via its own no-knockout fallback; here we try to reconcile them
                    // to a shared product line.
                    console.log('  All candidates knocked out — running no-knockout fallback reconciliation.');

                    // Re-score both pools without knockouts, still excluding AM/PM-incompatible products.
                    const scoreNoKo = (candidates) => {
                        const seen = new Set();
                        return candidates
                            .filter(p => { if (seen.has(p.id)) return false; seen.add(p.id); return true; })
                            .map(p => ({ p, score: this._getScoreBreakdown(p, routine, false).score }))
                            .filter(({ score }) => score >= 0)
                            .sort((a, b) => b.score - a.score);
                    };
                    const lotionCandidates   = this.allProducts['Hydrate'] || [];
                    const emulsionCandidates = (this.allProducts['Condition'] || []).filter(p => !p.variants?.some(v => v.sku === 'JVXC'));
                    const scoredLotions   = scoreNoKo(lotionCandidates);
                    const scoredEmulsions = scoreNoKo(emulsionCandidates);

                    console.log(`  No-knockout pool: ${scoredLotions.length} lotion(s), ${scoredEmulsions.length} emulsion(s)`);

                    if (!scoredLotions.length && !scoredEmulsions.length) {
                        console.warn('  No candidates available even without knockouts → no change.');
                        console.groupEnd();
                        return;
                    }

                    const hasLine = (p, line) =>
                        (p.meta?.product_lines || []).some(l => l.toLowerCase() === line.toLowerCase());

                    // Returns a lotion+emulsion pair from the given line (highest scorer of each), or null.
                    const findPair = (line) => {
                        const lotion   = scoredLotions.find(({ p }) => hasLine(p, line));
                        const emulsion = scoredEmulsions.find(({ p }) => hasLine(p, line));
                        return (lotion && emulsion) ? { lotion: lotion.p, emulsion: emulsion.p } : null;
                    };

                    let resolved = false;

                    // Step A: prefer the PM Moisturize product's line.
                    const pmMoisturizeGroup = this.ritualStepGroups['PM']?.find(g => g.label === 'Moisturize');
                    const pmMoisturizeLines = (pmMoisturizeGroup?.products[0] && !pmMoisturizeGroup.products[0].isEmpty)
                        ? (pmMoisturizeGroup.products[0].meta?.product_lines || [])
                        : [];

                    for (const line of pmMoisturizeLines) {
                        const pair = findPair(line);
                        if (pair) {
                            lotionGroup.products   = [pair.lotion];
                            emulsionGroup.products = [pair.emulsion];
                            console.log(`  Fallback (PM Moisturize line "${line}"): lotion → (${sku(pair.lotion)}) ${pair.lotion.title}, emulsion → (${sku(pair.emulsion)}) ${pair.emulsion.title}`);
                            resolved = true;
                            break;
                        }
                    }

                    // Step B: highest no-knockout scorer from either pool determines anchor line;
                    // lotion wins when scores are equal.
                    if (!resolved) {
                        const topLotion   = scoredLotions[0];
                        const topEmulsion = scoredEmulsions[0];

                        let anchorLine = null;
                        if (topLotion && topEmulsion) {
                            anchorLine = (topEmulsion.score - topLotion.score > 1e-9)
                                ? (topEmulsion.p.meta?.product_lines?.[0] || null)
                                : (topLotion.p.meta?.product_lines?.[0] || null);
                        } else {
                            const top = topLotion || topEmulsion;
                            anchorLine = top ? (top.p.meta?.product_lines?.[0] || null) : null;
                        }

                        if (anchorLine) {
                            const pair = findPair(anchorLine);
                            if (pair) {
                                lotionGroup.products   = [pair.lotion];
                                emulsionGroup.products = [pair.emulsion];
                                console.log(`  Fallback (anchor line "${anchorLine}"): lotion → (${sku(pair.lotion)}) ${pair.lotion.title}, emulsion → (${sku(pair.emulsion)}) ${pair.emulsion.title}`);
                                resolved = true;
                            } else {
                                // One retry: first distinct line found across all scored candidates.
                                const altLine = [...scoredLotions, ...scoredEmulsions]
                                    .map(({ p }) => (p.meta?.product_lines || [])[0])
                                    .filter(Boolean)
                                    .find(l => l.toLowerCase() !== anchorLine.toLowerCase());
                                if (altLine) {
                                    const pair2 = findPair(altLine);
                                    if (pair2) {
                                        lotionGroup.products   = [pair2.lotion];
                                        emulsionGroup.products = [pair2.emulsion];
                                        console.log(`  Fallback retry (alt line "${altLine}"): lotion → (${sku(pair2.lotion)}) ${pair2.lotion.title}, emulsion → (${sku(pair2.emulsion)}) ${pair2.emulsion.title}`);
                                        resolved = true;
                                    }
                                }
                            }
                        }

                        if (!resolved) {
                            // Last resort: keep each pool's independently best no-knockout scorer.
                            if (scoredLotions.length)   lotionGroup.products   = [scoredLotions[0].p];
                            if (scoredEmulsions.length) emulsionGroup.products = [scoredEmulsions[0].p];
                            console.warn(`  No same-line pair found — set independently: lotion → (${sku(lotionGroup.products[0])}) ${lotionGroup.products[0]?.title}, emulsion → (${sku(emulsionGroup.products[0])}) ${emulsionGroup.products[0]?.title}`);
                        }
                    }
                } else {
                    console.log('  Neither side tied → no change.');
                }
            }
            console.groupEnd();
        },
        // Breaks ties in the Moisturize slot using Q2 concern → product line affinity.
        // AM and PM are evaluated independently — only the tied side is filtered.
        _reconcileMoisturizeTie(routine, stepGroups) {
            const moisturizeGroup = stepGroups.find(g => g.label === 'Moisturize');
            if (!moisturizeGroup) return;

            const candidates = this.allProducts['Moisturize'] || [];
            const { tied, bestScore } = this._getTopScorers(candidates, routine);
            const sku = (p) => p?.variants?.[0]?.sku || '?';

            if (tied.length <= 1) {
                const winner = tied[0];
                console.log(`[Ritual ${routine}] Moisturize — no tie, winner: ${winner ? `(${sku(winner)}) ${winner.title}` : 'none'} (score ${bestScore})`);
                return;
            }

            const tiedLabel = tied.map(p => `(${sku(p)}) ${p.title}`).join(', ');

            // Collect preferred product lines from Q2 answers (union across all matched concerns)
            const q2Answers = (this.answers['step2'] || []).map(a => a.tag);
            const preferredLines = new Set(
                MOISTURIZE_CONCERNS
                    .filter(({ concern }) => q2Answers.includes(concern))
                    .map(({ line }) => line)
            );

            console.group(`[Ritual ${routine}] Moisturize TIE — ${tied.length} products share top score ${bestScore}: ${tiedLabel}`);

            if (preferredLines.size === 0) {
                console.log('  No Q2 answers matched MOISTURIZE_CONCERNS → no change.');
                console.groupEnd();
                return;
            }

            console.log(`  Preferred lines from Q2: ${[...preferredLines].join(', ')}`);

            // Intersect the preferred lines with the tied pool
            const preferred = tied.filter(p =>
                (p.meta?.product_lines || []).some(l => preferredLines.has(l.toLowerCase()))
            );

            if (preferred.length === 0) {
                console.log('  Intersection with tied pool is empty → no change.');
            } else {
                moisturizeGroup.products = [preferred[0]];
                console.log(`  → Tie broken: selected (${sku(preferred[0])}) ${preferred[0].title}`);
                if (preferred.length > 1) {
                    const remaining = preferred.slice(1).map(p => `(${sku(p)}) ${p.title}`).join(', ');
                    console.log(`  (${preferred.length - 1} other preferred candidate(s) also matched: ${remaining})`);
                }
            }

            console.groupEnd();
        },
        // Aligns the Lotion (Hydrate) and Emulsion (Condition) in the 6-step ritual toward
        // the Moisturize product's collection, while preserving their pairwise consistency.
        // Runs after _reconcileLayeringPair and _reconcileMoisturizeTie.
        _reconcileLayeringToMoisturize(routine, stepGroups) {
            const lotionGroup     = stepGroups.find(g => g.label === 'Hydrate' || g.label === 'Hydrate/Prep');
            const emulsionGroup   = stepGroups.find(g => g.label === 'Condition');
            const moisturizeGroup = stepGroups.find(g => g.label === 'Moisturize');
            if (!lotionGroup || !emulsionGroup || !moisturizeGroup) return;

            // Always use the PM moisturize product as the anchor so that an AM-only
            // moisturizer (e.g. SPF day cream) cannot pull AM lotion/emulsion to a
            // different line than PM. PM is built first in getRitualProducts.
            const pmMoisturizeGroup = this.ritualStepGroups['PM']?.find(g => g.label === 'Moisturize');
            const anchorProduct = (pmMoisturizeGroup?.products[0] && !pmMoisturizeGroup.products[0].isEmpty)
                ? pmMoisturizeGroup.products[0]
                : moisturizeGroup.products[0];
            const moisturizeProduct = anchorProduct;
            if (!moisturizeProduct || moisturizeProduct.isEmpty) return;

            const moisturizeLine = (moisturizeProduct.meta?.product_lines || []).map(l => l.toLowerCase());
            if (!moisturizeLine.length) return;

            const chosenLotion   = lotionGroup.products[0];
            const chosenEmulsion = emulsionGroup.products[0];
            if (!chosenLotion || chosenLotion.isEmpty || !chosenEmulsion || chosenEmulsion.isEmpty) return;

            const sku      = (p) => p?.variants?.[0]?.sku || '?';
            const linesOf  = (p) => (p.meta?.product_lines || []).map(l => l.toLowerCase());
            const hasLine  = (p, lines) => linesOf(p).some(l => lines.includes(l));
            const sameLine = (a, b)     => linesOf(a).some(l => linesOf(b).includes(l));

            if (hasLine(chosenLotion, moisturizeLine) && hasLine(chosenEmulsion, moisturizeLine)) {
                console.log(`[Ritual ${routine}] Layering→Moisturize: both already match moisturize line → no change.`);
                return;
            }

            const lotionTie   = this._getTopScorers(this.allProducts['Hydrate'] || [], routine).tied;
            const emulsionTie = this._getTopScorers(
                (this.allProducts['Condition'] || []).filter(p => !p.variants?.some(v => v.sku === 'JVXC')),
                routine
            ).tied;

            console.group(`[Ritual ${routine}] Layering → Moisturize reconciliation (moisturize line: ${moisturizeLine.join(', ')})`);
            console.log(`  Lotion:   (${sku(chosenLotion)}) ${chosenLotion.title} — tied: ${lotionTie.length > 1}`);
            console.log(`  Emulsion: (${sku(chosenEmulsion)}) ${chosenEmulsion.title} — tied: ${emulsionTie.length > 1}`);

            const lotionMatches   = lotionTie.filter(p => hasLine(p, moisturizeLine));
            const emulsionMatches = emulsionTie.filter(p => hasLine(p, moisturizeLine));

            // Priority 1: paired swap — both sides move to the moisturize line together
            for (const l of lotionMatches) {
                for (const e of emulsionMatches) {
                    if (sameLine(l, e)) {
                        lotionGroup.products   = [l];
                        emulsionGroup.products = [e];
                        console.log(`  Paired swap: lotion → (${sku(l)}) ${l.title}, emulsion → (${sku(e)}) ${e.title}`);
                        console.groupEnd();
                        return;
                    }
                }
            }

            // Priority 2: move lotion to moisturize line while it still matches current emulsion
            const newLotion = lotionMatches.find(p => sameLine(p, chosenEmulsion));
            if (newLotion) {
                lotionGroup.products = [newLotion];
                console.log(`  Lotion swapped: (${sku(newLotion)}) ${newLotion.title} (matches moisturize line + emulsion)`);
                console.groupEnd();
                return;
            }

            // Priority 3: move emulsion to moisturize line while it still matches current lotion
            const newEmulsion = emulsionMatches.find(p => sameLine(p, chosenLotion));
            if (newEmulsion) {
                emulsionGroup.products = [newEmulsion];
                console.log(`  Emulsion swapped: (${sku(newEmulsion)}) ${newEmulsion.title} (matches moisturize line + lotion)`);
                console.groupEnd();
                return;
            }

            console.log('  Cannot align to moisturize line without breaking Lotion↔Emulsion consistency → no change.');
            console.groupEnd();
        },
        async getRitualProducts() {
            console.log('Quiz answers by step:', Object.fromEntries(
                Object.entries(this.answers).map(([step, answer]) => [step, answer])
            ));
            const ritualSizeAnswer = this.answers.step8?.tag;
            const layeringAnswer = this.answers.step6?.tag;
            let ritualSize = 'small';

            if (ritualSizeAnswer === 'dsk-quiz-ritual-advanced') {
                ritualSize = (layeringAnswer === 'dsk-quiz-layering-yes' || layeringAnswer === 'dsk-quiz-layering-one') ? 'large-6' : 'large-5';
            }

            this.buildRitual('PM', ritualSize);
            this.buildRitual('AM', ritualSize);
            console.log('Ritual collections:', { AM: this.ritualCollection['AM'], PM: this.ritualCollection['PM'] });
            this.triggerQuizCompletionReward();
            this.preResultsVisible = true;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        proceedToResults() {
            this.preResultsVisible = false;
            this.quizCompleted = true;
            this.$nextTick(() => {
                // Results header (with AM/PM toggle) has just mounted — get a fresh
                // measurement immediately instead of waiting for the next scroll/resize.
                this.setHeaderOffset();

                const footer = document.querySelector('.dsk-quiz-sticky-footer');
                const products = document.querySelector('[data-footer-region="products"]');
                if (!footer || !products) return;
                this.footerObserver = new IntersectionObserver(([e]) => {
                    const hidden = !e.isIntersecting && e.boundingClientRect.top < 0;
                    footer.classList.toggle('footer-hidden', hidden);
                    this.footerHidden = hidden;
                }, { threshold: 0 });
                this.footerObserver.observe(products);

                // Mobile: hide the sticky footer while a scroll is in progress, and only let it
                // reappear (in the ritual area, per the observer above) once scrolling settles.
                this.footerScrollHandler = () => {
                    footer.classList.add('is-scrolling');
                    clearTimeout(this.footerScrollSettleTimer);
                    this.footerScrollSettleTimer = setTimeout(() => {
                        footer.classList.remove('is-scrolling');
                    }, 150);
                };
                window.addEventListener('scroll', this.footerScrollHandler, { passive: true });
            });
        },
        getProductAmPmBadges(productId) {
            // Helper to find a product by its ID from any of the available product lists.
            const findProductData = (id) => {
                // First, check the calculated rituals as they are the most relevant.
                let product = this.ritualProducts['AM']?.find(p => p.id === id) || 
                              this.ritualProducts['PM']?.find(p => p.id === id);
                if (product) return product;

                // As a fallback, search through all products fetched initially.
                for (const step in this.allProducts) {
                    product = this.allProducts[step].find(p => p.id === id);
                    if (product) return product;
                }
                // Also search rawAllProducts (covers carousel/addon products without a ritual step).
                if (this.rawAllProducts) {
                    product = this.rawAllProducts.find(p => p.id === id);
                    if (product) return product;
                }
                return null;
            };

            const product = findProductData(productId);

            if (!product || product.isEmpty) {
                return { showAm: false, showPm: false, hasAmPm: false };
            }

            const amPm = product.meta.am_pm?.toLowerCase();

            // If 'am_pm' is not set, or is 'both', it's suitable for both routines.
            if (!amPm || amPm === 'both') {
                return { showAm: true, showPm: true, hasAmPm: true };
            }
            
            // Otherwise, show the specific badge.
            return { showAm: amPm === 'am', showPm: amPm === 'pm', hasAmPm: true };
        },
        getModerateCarouselProductPool() {
            if (!this.rawAllProducts) return {};
            const allCarouselProducts = this.rawAllProducts.filter(p => p.meta?.carousel === true);

            const pool = {}; // {sku: "serum" | "other" | "hydrate" | "condition"}

            allCarouselProducts.forEach(p => {
                const category = p.meta?.carousel_category?.toLowerCase();
                p.variants?.forEach(v => {
                    if (!v.sku) return;
                    if (category === 'serum') pool[v.sku] = 'serum';
                    else if (category === 'other') pool[v.sku] = 'other';
                });
            });

            allCarouselProducts
                .filter(p => p.meta?.ritual_step === 'Hydrate')
                .forEach(p => p.variants?.forEach(v => { if (v.sku) pool[v.sku] = 'hydrate'; }));

            allCarouselProducts
                .filter(p => p.meta?.ritual_step === 'Condition')
                .forEach(p => p.variants?.forEach(v => { if (v.sku) pool[v.sku] = 'condition'; }));

            return pool;
        },
        get carouselProducts() {
            if (!this.rawAllProducts) return [];

            const findBySku = (sku) => this.rawAllProducts.find(
                p => p.variants?.some(v => v.sku === sku)
            );

            const guasha = findBySku('JQZC');
            const cottonSheets = findBySku('JQCY');

            const best = (arr, label) => {
                const seen = new Set();
                const unique = arr.filter(p => { if (seen.has(p.id)) return false; seen.add(p.id); return true; });
                const scoreLog = unique.map(p => {
                    const { score, detail } = this._getScoreBreakdown(p, null);
                    const sku = p.variants[0]?.sku || '?';
                    return { product: p, sku, score, detail };
                }).filter(({ score }) => score >= 0)
                  .sort((a, b) => b.score - a.score);

                console.group(`[Carousel] ${label} — ${unique.length} candidate(s)`);
                scoreLog.forEach(({ product, sku, score, detail }, i) => {
                    const selected = i === 0;
                    console.log(`${selected ? '★ SELECTED  ' : '            '}(${sku}) ${product.title}  →  score ${score.toFixed(3)}\n${detail}`);
                });
                if (scoreLog.length === 0) console.warn('  No qualifying products found');
                console.groupEnd();

                return scoreLog[0]?.product || null;
            };

            const bestRandom = (arr, label) => {
                const seen = new Set();
                const unique = arr.filter(p => { if (seen.has(p.id)) return false; seen.add(p.id); return true; });
                const scoreLog = unique.map(p => {
                    const { score, detail } = this._getScoreBreakdown(p, null);
                    const sku = p.variants[0]?.sku || '?';
                    return { product: p, sku, score, detail };
                }).filter(({ score }) => score >= 0)
                  .sort((a, b) => b.score - a.score);

                if (scoreLog.length === 0) {
                    console.group(`[Carousel] ${label} — 0 candidate(s)`);
                    console.warn('  No qualifying products found');
                    console.groupEnd();
                    return null;
                }

                const topScore = scoreLog[0].score;
                const tied = scoreLog.filter(({ score }) => Math.abs(score - topScore) < 1e-9);
                const pick = tied[Math.floor(Math.random() * tied.length)];

                console.group(`[Carousel] ${label} — ${unique.length} candidate(s), ${tied.length} tied at top`);
                scoreLog.forEach(({ product, sku, score, detail }) => {
                    const selected = product.id === pick.product.id;
                    console.log(`${selected ? '★ SELECTED  ' : '            '}(${sku}) ${product.title}  →  score ${score.toFixed(3)}\n${detail}`);
                });
                console.groupEnd();

                return pick.product;
            };

            const isModerate = this.answers?.step8?.tag !== 'dsk-quiz-ritual-advanced';
            const layeringAnswer = this.answers?.step6?.tag;

            console.group(`[Carousel] Building carousel — ritual: ${isModerate ? 'moderate' : 'advanced'}, routine: ${this.activeRoutine}, layering: ${layeringAnswer || 'none'}`);
            console.log(`  Fixed slots: guasha=${guasha ? `(JQZC) ${guasha.title}` : 'NOT FOUND'}, cottonSheets=${cottonSheets ? `(JQCY) ${cottonSheets.title}` : 'NOT FOUND'}`);

            const routine = this.activeRoutine;
            const collection = this.ritualCollection['PM'];
            const matchesCollection = (p) => !collection || (p.meta?.product_lines || []).includes(collection);
            console.log(`  Collection filter: ${collection || 'none (no filter)'}`);

            let result;

            if (isModerate) {
                const fixedSkus = new Set(['JQZC', 'JQCY', 'JVXC']);

                if (layeringAnswer === 'dsk-quiz-layering-familiar' || layeringAnswer === 'dsk-quiz-layering-new') {
                    // New to layering: fixed + JVXC + highest-scoring carousel serum
                    const jvxc = findBySku('JVXC');
                    console.log(`  JVXC slot: ${jvxc ? `(JVXC) ${jvxc.title}` : 'NOT FOUND'}`);
                    const carouselBase = this.rawAllProducts
                        .filter(p => p.meta?.carousel === true)
                        .filter(p => !p.variants?.some(v => fixedSkus.has(v.sku)))
                        .filter(p => p.meta?.carousel_category?.toLowerCase() === 'serum')
                        .filter(p => p.meta?.ritual_step !== 'Condition' && p.meta?.ritual_step !== 'Hydrate');
                    console.log(`  carouselBase (serum category only): ${carouselBase.length} products`);
                    const inCollection = carouselBase.filter(matchesCollection);
                    console.log(`  inCollection subset: ${inCollection.length} products`);
                    const serum = best(inCollection, 'serum (in-collection)') || best(carouselBase, 'serum (fallback, all)');
                    result = [guasha, cottonSheets, jvxc, serum].filter(Boolean);
                } else {
                    // Already layers (yes/one): fixed + highest-scoring hydrate + highest-scoring condition
                    const lotionCandidates = this.rawAllProducts.filter(p => p.meta?.carousel === true && p.meta?.ritual_step === 'Hydrate' && p.meta?.carousel_excl_layering?.toLowerCase() !== 'moderate');
                    const emulsionCandidates = this.rawAllProducts.filter(p => p.meta?.carousel === true && p.meta?.ritual_step === 'Condition' && p.meta?.carousel_excl_layering?.toLowerCase() !== 'moderate');
                    console.log(`  Hydrate candidates: ${lotionCandidates.length}, Condition candidates: ${emulsionCandidates.length}`);
                    let lotion = best(lotionCandidates.filter(matchesCollection), 'Hydrate/Lotion (in-collection)') || best(lotionCandidates, 'Hydrate/Lotion (fallback, all)');
                    let emulsion = best(emulsionCandidates.filter(matchesCollection), 'Condition/Emulsion (in-collection)') || best(emulsionCandidates, 'Condition/Emulsion (fallback, all)');

                    // Reconcile the carousel Lotion/Emulsion pair so they share a product line,
                    // mirroring _reconcileLayeringPair for the ritual grid. Re-pick the tied side
                    // toward the single winner; if both tie, neither ties, or they already match,
                    // leave the selection unchanged.
                    if (lotion && emulsion) {
                        const lineOf = (p) => p?.meta?.product_lines || [];
                        const sameLine = (a, b) => lineOf(a).some(line => lineOf(b).includes(line));
                        const skuOf = (p) => p?.variants?.[0]?.sku || '?';

                        // Tie set among carousel candidates, using the same scoring/filtering as
                        // best(): in-collection first, then fall back to all candidates.
                        const tieSet = (candidates) => {
                            const score = (arr) => {
                                const seen = new Set();
                                return arr
                                    .filter(p => { if (seen.has(p.id)) return false; seen.add(p.id); return true; })
                                    .map(p => ({ p, score: this._getScoreBreakdown(p, null).score }))
                                    .filter(({ score }) => score >= 0)
                                    .sort((a, b) => b.score - a.score);
                            };
                            let scored = score(candidates.filter(matchesCollection));
                            if (!scored.length) scored = score(candidates);
                            if (!scored.length) return [];
                            const top = scored[0].score;
                            return scored.filter(({ score }) => Math.abs(score - top) < 1e-9).map(({ p }) => p);
                        };

                        if (sameLine(lotion, emulsion)) {
                            console.log('  Reconcile: carousel lotion already matches emulsion line → no change.');
                        } else {
                            const lotionTie = tieSet(lotionCandidates);
                            const emulsionTie = tieSet(emulsionCandidates);
                            const lotionTied = lotionTie.length > 1;
                            const emulsionTied = emulsionTie.length > 1;

                            if (lotionTied && !emulsionTied) {
                                const match = lotionTie.find(p => sameLine(p, emulsion));
                                if (match) {
                                    lotion = match;
                                    console.log(`  Reconcile: swapped carousel lotion → (${skuOf(match)}) ${match.title} to match emulsion line.`);
                                } else {
                                    console.warn('  Reconcile: no tied carousel lotion matches emulsion line → unchanged.');
                                }
                            } else if (emulsionTied && !lotionTied) {
                                const match = emulsionTie.find(p => sameLine(p, lotion));
                                if (match) {
                                    emulsion = match;
                                    console.log(`  Reconcile: swapped carousel emulsion → (${skuOf(match)}) ${match.title} to match lotion line.`);
                                } else {
                                    console.warn('  Reconcile: no tied carousel emulsion matches lotion line → unchanged.');
                                }
                            } else {
                                console.log('  Reconcile: both sides tied or neither tied → no change.');
                            }
                        }
                    }

                    result = [guasha, cottonSheets, lotion, emulsion].filter(Boolean);
                }
            } else {
                // Advanced ritual — existing logic
                const advancedExcludedSteps = new Set(['Condition', 'Hydrate']);
                const fixedSkus = new Set(['JQZC', 'JQCY']);
                const pool = this.rawAllProducts
                    .filter(p => p.meta && p.meta.carousel === true)
                    .filter(p => !p.variants?.some(v => fixedSkus.has(v.sku)))
                    .filter(p => !advancedExcludedSteps.has(p.meta.ritual_step));
                console.log(`  Advanced pool (excl. fixed, Condition, Hydrate): ${pool.length} products`);

                const isSerum = (p) => p.meta?.carousel_category?.toLowerCase() === 'serum';
                const isOther = (p) => p.meta?.carousel_category?.toLowerCase() === 'other';
                const serumCandidates = pool.filter(isSerum);
                const otherCandidates = pool.filter(isOther);
                const bestSerum = best(serumCandidates.filter(matchesCollection), 'Serum (in-collection)') || best(serumCandidates, 'Serum (fallback, all)');
                const bestOther = bestRandom(otherCandidates.filter(matchesCollection), 'Other (in-collection, randomized)') || bestRandom(otherCandidates, 'Other (fallback, all, randomized)');
                result = [guasha, cottonSheets, bestSerum, bestOther].filter(Boolean);
            }

            console.log(`[Carousel] Final slots: [${result.map(p => `(${p.variants[0]?.sku || '?'}) ${p.title}`).join(', ')}]`);
            console.groupEnd();

            return result;
        },
        async debugFetchAllLogicRules() {
            let allRules = [];
            let hasNextPage = true;
            let cursor = null;
            const BATCH_SIZE = 50;

            while (hasNextPage) {
                const query = `
                    query debugFetchAllLogicRules {
                      metaobjects(type: "dsk_quiz_logic_rule", first: ${BATCH_SIZE}${cursor ? `, after: "${cursor}"` : ''
                    }) {
                        edges {
                          node {
                            id
                            handle
                            product: field(key: "product_reference") {
                              reference {
                                ... on Product {
                                  id
                                  title
                                }
                              }
                            }
                            questionId: field(key: "question_id") {
                              value
                            }
                            eligibleAnswers: field(key: "eligible_answers") {
                              references(first: 50) {
                                edges {
                                  node {
                                    ... on Metaobject {
                                      id
                                      answer: field(key: "answer") {
                                        value
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                        pageInfo {
                          hasNextPage
                          endCursor
                        }
                      }
                    }
                `;

                try {
                    const response = await fetch(`${this.storeUrl}/api/2026-04/graphql.json`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Shopify-Storefront-Access-Token": this.storefrontToken,
                        },
                        body: JSON.stringify({ query }),
                    });
                    const result = await response.json();

                    if (result.errors) {
                        console.error("GraphQL Errors fetching all logic rules for debug:", result.errors);
                        hasNextPage = false;
                    } else if (result.data && result.data.metaobjects) {
                        allRules = allRules.concat(result.data.metaobjects.edges);
                        hasNextPage = result.data.metaobjects.pageInfo.hasNextPage;
                        cursor = result.data.metaobjects.pageInfo.endCursor;
                    } else {
                        console.error("Unexpected response structure for debug logic rules fetch:", result);
                        hasNextPage = false;
                    }
                } catch (error) {
                    console.error("Error fetching all quiz logic rules for debug:", error);
                    hasNextPage = false;
                }
            }

            const formattedRules = allRules.map(({ node }) => {
                const eligibleAnswers = node.eligibleAnswers?.references?.edges.map(edge => edge.node.answer?.value).filter(Boolean) || [];
                return {
                    handle: node.handle,
                    product: node.product?.reference?.title || 'No Product',
                    questionId: node.questionId?.value,
                    eligibleAnswers: eligibleAnswers,
                };
            });
            console.log('Retrieved logic rules:', formattedRules);
        },
        async fetchQuizLogicRules() {
            let allRules = [];
            let hasNextPage = true;
            let cursor = null;

            while (hasNextPage) {
                const query = `
{
  dskQuizLogicRules: metaobjects(
    type: "dsk_quiz_logic_rule"
    first: 100
    ${cursor ? `after: "${cursor}"` : ""}
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        product: field(key: "product_reference") {
          reference {
            ... on Product {
              id
              title
              description
              featuredImage {
                id
                url
                altText
              }
              images(first: 5) {
                edges {
                  node {
                    id
                    url
                    altText
                  }
                }
              }
              handle
              priceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
              }
              tags
              # The namespace for the descriptor metafield is assumed to be "custom".
              descriptor: metafield(key: "Descriptor", namespace: "custom") {
                value
              }
              # The namespace for the key benefits metafield is "custom" and the key is "key_benefits".
              keyBenefits: metafield(key: "key_benefits", namespace: "custom") {
                value
              }
                        shortDescription: metafield(key: "short_description", namespace: "custom") {
                          value
                        }
            }
          }
        }
        questionId: field(key: "question_id") {
          value
        }
        eligibleAnswers: field(key: "eligible_answers") {
          references(first: 250) {
            pageInfo {
              hasNextPage
              endCursor
            }
            edges {
              node {
                ... on Metaobject {
                  id
                  questionId: field(key: "question_id") {
                    value
                  }
                  answer: field(key: "answer") {
                    value
                  }
                }
              }
            }
          }
        }
        amPm: field(key: "am_pm") {
          value
        }
        carousel: field(key: "carousel") {
          value
        }
      }
    }
  }
}
                `;

                try {
                    const response = await fetch(`${this.storeUrl}/api/2026-04/graphql.json`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Shopify-Storefront-Access-Token": this.storefrontToken,
                        },
                        body: JSON.stringify({ query }),
                    });

                    const result = await response.json();
                    
                    if (result.errors) {
                        console.error("GraphQL Errors fetching logic rules:", result.errors);
                        this.apiError = true;
                        hasNextPage = false;
                    } else { 
                        allRules = allRules.concat(result.data.dskQuizLogicRules.edges);
                        hasNextPage = result.data.dskQuizLogicRules.pageInfo.hasNextPage;
                        cursor = result.data.dskQuizLogicRules.pageInfo.endCursor;
                    }
                } catch (error) {
                    console.error("Error fetching quiz logic rules:", error);
                    this.apiError = true;
                    hasNextPage = false;
                }
            }

            this.quizLogicRules = this._parseLogicRules({ edges: allRules });
        },
        _parseLogicRules(metaobjectsData) {
            const rules = {};
            
            metaobjectsData.edges.forEach((edge, idx) => {
                const rule = edge.node;
                
                // Safely access the product reference
                const product = rule.product?.reference;
                const productId = product?.id;
                
                if (!productId) {
                    // console.warn(`Rule ${idx}: Skipping - no product reference found. Product object:`, rule.product);
                    return;
                }
                
                // Check if eligible answers exist and have data
                const eligibleAnswersData = rule.eligibleAnswers?.references?.edges;
                
                if (!eligibleAnswersData || eligibleAnswersData.length === 0) {
                    // console.warn(`Rule ${idx}: No eligible answers found for product ${product.title}`);
                    return;
                }
                
                if (!rules[productId]) {
                    rules[productId] = {
                        product: {
                            id: product.id,
                            title: product.title,
                            description: product.description,
                            handle: product.handle,
                            featuredImage: product.featuredImage,
                            images: product.images.edges.map(e => e.node),
                            priceRange: product.priceRange,
                            tags: product.tags,
                            descriptor: product.descriptor?.value, // Assuming 'Descriptor' is the key for this metafield
                            shortDescription: product.shortDescription?.value,
                            keyBenefits: product.keyBenefits ? JSON.parse(product.keyBenefits.value) : []
                        },
                        rules: []
                    };
                }

                const questionId = parseInt(rule.questionId.value);
                const eligibleAnswers = eligibleAnswersData.map(ref => {
                    const answerValue = ref.node.answer?.value;
                    if (!answerValue) {
                        // console.warn(`Rule ${idx}: Missing answer value for question ${questionId}`);
                    }
                    return {
                        questionId: parseInt(ref.node.questionId?.value || questionId),
                        answer: answerValue
                    };
                }).filter(ea => ea.answer); // Filter out entries without answers

                if (eligibleAnswers.length > 0) {
                    const existingRule = rules[productId].rules.find(r => r.questionId === questionId);
                    if (existingRule) {
                        eligibleAnswers.forEach(ea => {
                            if (!existingRule.eligibleAnswers.some(e => e.answer === ea.answer)) {
                                existingRule.eligibleAnswers.push(ea);
                            }
                        });
                    } else {
                        rules[productId].rules.push({
                            questionId: questionId,
                            eligibleAnswers: eligibleAnswers,
                            amPm: rule.amPm?.value || '',
                            carousel: rule.carousel?.value === "true"
                        });
                    }
                } else {
                    // console.warn(`Rule ${idx}: No valid eligible answers for product ${product.title}`);
                }
            });
            return rules;
        },
        questions: [
            {
                step: 1,
                type: question_types.SINGLE_IMG_2_COL,
                text: 'What is your skin type?',
                subtitle: 'Select the option that best describes your skin.',
                options: [
                    { name: 'Normal', desc: 'My skin feels balanced and comfortable.', shopTag: 'dsk-quiz-type-normal', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-st-normal.png?v=1779274169' },
                    { name: 'Dry', desc: 'My skin often feels tight or uncomfortable and often needs more moisture.', shopTag: 'dsk-quiz-type-dry', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-st-dry.png?v=1779274138' },
                    { name: 'Oily', desc: 'My skin becomes shiny throughout the day, and I have visible pores and/or breakout.', shopTag: 'dsk-quiz-type-oily', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-st-oily.png?v=1779470612' },
                    { name: 'Combination', desc: 'Some areas feel oily while other areas feel dry.', shopTag: 'dsk-quiz-type-comb', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-st-comb.png?v=1779274161' }
                ]
            },
            {
                step: 2,
                type: question_types.MULTIPLE_2_COL,
                limit: 3,
                text: 'What are your top skincare concerns right now?',
                subtitle: 'Select up to 3 answers.',
                options: [
                    { name: 'Fine Lines & Wrinkles', desc: '', shopTag: 'dsk-quiz-concerns-fine-lines-wrinkles' },
                    { name: 'Unhealthy Skin', desc: '', shopTag: 'dsk-quiz-concerns-unhealthy-skin' },
                    { name: 'Loss of Firmness', desc: '', shopTag: 'dsk-quiz-concerns-loss-of-firmness' },
                    { name: 'Sagging', desc: '', shopTag: 'dsk-quiz-concerns-sagging' },
                    { name: 'Dryness/Dehydration', desc: '', shopTag: 'dsk-quiz-concerns-dryness-dehydration' },
                    { name: 'Thinning Skin', desc: '', shopTag: 'dsk-quiz-concerns-thinning' },
                    { name: 'Dullness', desc: '', shopTag: 'dsk-quiz-concerns-dullness' },
                    { name: 'Dark Circles', desc: '', shopTag: 'dsk-quiz-concerns-dark-circles' },
                    { name: 'Uneven Texture', desc: '', shopTag: 'dsk-quiz-concerns-uneven-texture' },
                    { name: 'Puffiness', desc: '', shopTag: 'dsk-quiz-concerns-puffiness' },
                    { name: 'Hyperpigmentation/Dark Spots', desc: '', shopTag: 'dsk-quiz-concerns-hyperpigmentation' },
                ]
            },
            {
                step: 3,
                text: 'What is your age range?',
                subtitle: '',
                ctaTitle: 'Why we ask this',
                infoImage: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-age-overlay.png',
                infoText: ` <p><span style="font-weight: 600;">Age</span> offers insight into your <span style="font-weight: 600;">skin’s natural rhythm</span> and how it evolves over time. At <span style="font-weight: 600;">DECORTÉ</span>, we consider this alongside your <span style="font-weight: 600;">skin concerns, lifestyle, and preferences</span> to create a <span style="font-weight: 600;">personalized ritual</span> that supports skin at <span style="font-weight: 600;">every stage</span>.</p>`,
                type: question_types.SINGLE_1_COL,
                options: [
                    { name: '18-24', desc: '', shopTag: 'dsk-quiz-age-18-24' },
                    { name: '25-34', desc: '', shopTag: 'dsk-quiz-age-25-34' },
                    { name: '35-44', desc: '', shopTag: 'dsk-quiz-age-35-44' },
                    { name: '45-54', desc: '', shopTag: 'dsk-quiz-age-45-54' },
                    { name: '55+', desc: '', shopTag: 'dsk-quiz-age-55-plus' }
                ]
            },
            {
                step: 4,
                type: question_types.SINGLE_IMG_2_COL,
                text: 'How does your skin feel throughout the day?',
                subtitle: 'Select the option that best describes your skin.',                 
                options: [
                    { name: 'Tight and Dry', desc: '', shopTag: 'dsk-quiz-feel-tight', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-sf-tight-dry.png?v=1783451693', interstitialHtml: `
<p>Your skin may feel <span style="font-weight: 600;">dry, tight, or change throughout the day</span>—signs that its moisture balance has shifted. When skin lacks moisture, it can appear <span style="font-weight: 600;">dull and feel less comfortable</span>, making <span style="font-weight: 600;">hydration essential to keeping it smooth, resilient, and healthy</span>.</p>
<p>At <span style="font-weight: 600;">DECORTÉ</span>, we restore balance through <span style="font-weight: 600;">lightweight layers of hydration</span>, rooted in <span style="font-weight: 600;">Japanese wellness philosophy</span> and powered by <span style="font-weight: 600;">advanced delivery technologies</span>.</p>
                    ` },
                    { name: 'Balanced', desc: '', shopTag: 'dsk-quiz-feel-balanced', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-sf-balanced.png?v=1783451678', interstitialHtml: `
<p>When your skin feels <span style="font-weight: 600;">balanced throughout the day</span>—that's a sign it’s functioning in a state of harmony. Maintaining that balance is essential to keeping skin <span style="font-weight: 600;">smooth, resilient, and healthy-looking</span>.</p>
<p>At <span style="font-weight: 600;">DECORTÉ</span>, we help preserve and support balance through <span style="font-weight: 600;">lightweight layers of hydration</span>—rooted in <span style="font-weight: 600;">Japanese wellness philosophy</span> and powered by <span style="font-weight: 600;">advanced delivery technologies</span>.</p>
                    ` },
                    { name: 'Shiny/Oily by Mid-day', desc: '', shopTag: 'dsk-quiz-feel-shiny-oily', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-sf-shiny-oily.png?v=1783451686', interstitialHtml: `
<p>Your skin may feel <span style="font-weight: 600;">shiny, oily, or change throughout the day</span>—a sign its natural balance has shifted. When excess oil builds, skin can appear uneven and feel less comfortable, making <span style="font-weight: 600;">balance key to healthy-looking complexion</span>.</p>
<p>At <span style="font-weight: 600;">DECORTÉ</span>, we help restore balance by <span style="font-weight: 600;">hydrating and refining</span> through precise, <span style="font-weight: 600;">lightweight layers</span>—rooted in <span style="font-weight: 600;">Japanese wellness philosophy</span> and powered by <span style="font-weight: 600;">advanced delivery technologies</span>.</p>
                    ` },
                    { name: 'Flaky/Patchy', desc: '', shopTag: 'dsk-quiz-feel-flaky-patchy', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-sf-flaky-patchy.png?v=1783451673', interstitialHtml: `
<p>Your skin may feel <span style="font-weight: 600;">flaky, patchy, or out of sync throughout the day</span>—these shifts reflect a lack of <span style="font-weight: 600;">balance</span>. When skin isn’t properly conditioned, it can feel <span style="font-weight: 600;">rough, appear dull, and lose its smooth texture</span>.</p>
<p>At <span style="font-weight: 600;">DECORTÉ</span>, we restore <span style="font-weight: 600;">balance</span> by replenishing the skin with <span style="font-weight: 600;">lightweight layers of hydration</span>—rooted in <span style="font-weight: 600;">Japanese wellness philosophy</span> and <span style="font-weight: 600;">advanced delivery technologies</span>.</p>
                    ` }
                ]
            },
            {
                step: 5,
                type: question_types.MULTIPLE_IMG_2_COL,
                limit: 2,
                text: 'When shopping for skincare products, what ingredients are you most interested in?',
                subtitle: 'Select 2 answers.',
                options: [
                    { name: 'Peptides', desc: 'Skin-strengthening ingredients that help improve firmness, smooth the look of fine lines, and support a more resilient complexion.', shopTag: 'dsk-quiz-ingredients-peptides', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-in-peptides.png?v=1777051472' },
                    { name: 'Ceramides', desc: 'Skin-identical lipids that help strengthen the moisture barrier and lock in hydration for smooth, resilient skin.', shopTag: 'dsk-quiz-ingredients-ceramides', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-in-ceramides.png?v=1777051472' },
                    { name: 'Retinols and Alpha-hydroxys', desc: 'Advanced ingredients that accelerate skin renewal to improve the look of fine lines, texture, and uneven tone.', shopTag: 'dsk-quiz-ingredients-retinols-alpha-hydoxys', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-in-retinols-hydrox.png?v=1777051472' },
                    { name: 'Vitamin C', desc: 'A powerful antioxidant that helps brighten skin, support collagen, and protect against environmental stressors.', shopTag: 'dsk-quiz-ingredients-vitamin-c', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-in-vitamin-c.png?v=1777051472' },
                    { name: 'Hyaluronic Acid', desc: 'A super hydrator that attracts and holds moisture to help keep skin plump, smooth, and supple.', shopTag: 'dsk-quiz-ingredients-hyaluronic-acid', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-in-hyaluronic.png?v=1777051472' },
                    { name: 'Niacinamide', desc: 'A multi-tasking ingredient that helps strengthen the skin barrier, even tone, and smooth the look of  fine lines.', shopTag: 'dsk-quiz-ingredients-niacinamide', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-in-niacinamide.png?v=1777051472' }
                ]
            },
            {
                step: 6,
                type: question_types.SINGLE_HEADER_IMG_2_COL,
                headerImg: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-le-header.png?v=1779274817',
                text: 'Do you currently practice the Japanese skincare layering ritual of using a Lotion and Emulsion?',
                subtitle: '',
                ctaTitle: 'What is a Japanese Lotion and Emulsion?',
                infoImage: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-le-header.png?v=1779274832',
                infoText: `
                    <p>In Japanese skincare, hydration is the foundation of healthy-looking skin—layered through lightweight steps like lotion and emulsion.</p>
                    <p><span style="font-weight: 600;">What is a Japanese Lotion?</span></p>
                    <p>A lightweight, water-like step used after cleansing to <span style="font-weight: 600;">hydrate and prepare</span> the skin for what follows.</p>
                    <p><span style="font-weight: 600;">What is a Japanese Emulsion?</span></p>
                    <p>A soft, milky moisturizer</span> that helps nourish the skin and <span style="font-weight: 600;">seal in hydration</span>.</p>
                `,
                interstitialHtml: ``, // This will be set dynamically based on the user's answer
                options: [
                    { name: '', desc: 'Yes - I use both Lotion and Emulsion regularly.', shopTag: 'dsk-quiz-layering-yes', interstitialHtml: `
                        <p>In <span style="font-weight: 600;">Japanese skincare, hydration is not a single step</span>—it's a layering ritual that brings skin into balance.</p>
                        <p>Unlike traditional skincare rituals, <span style="font-weight: 600;">DECORTÉ begins with Emulsion</span> to condition skin, allowing Lotion to absorb more effectively for <span style="font-weight: 600;">smoother, more supple, visibly radiant skin</span>.</p>
                        <p>Incorporating <span style="font-weight: 600;">both steps</span> into your ritual helps reveal <span style="font-weight: 600;">beautifully balanced, healthier-looking skin</span>.</p>
                    `},
                    { name: '', desc: 'I use one, but not both.', shopTag: 'dsk-quiz-layering-one', interstitialHtml: `
                        <p>In <span style="font-weight: 600;">Japanese skincare, hydration is not a single step</span>—it's a layering ritual that brings skin into balance.</p>
                        <p>Unlike traditional skincare rituals, <span style="font-weight: 600;">DECORTÉ begins with Emulsion</span> to condition skin, allowing Lotion to absorb more effectively for <span style="font-weight: 600;">smoother, more supple, visibly radiant skin</span>.</p>
                        <p>Incorporating <span style="font-weight: 600;">both steps</span> into your ritual helps reveal <span style="font-weight: 600;">beautifully balanced, healthier-looking skin</span>.</p>
                    `},
                    { name: '', desc: 'I\'m familiar with the ritual, but don\'t currently follow it.', shopTag: 'dsk-quiz-layering-familiar', interstitialHtml: `
                        <p>In <span style="font-weight: 600;">Japanese skincare, hydration is not a single step</span>—it’s a <span style="font-weight: 600;">layering ritual</span> that brings skin into balance.</p>
                        <p>Inspired by this ritual, <span style="font-weight: 600;">DECORTÉ's advanced all-in-one essences</span> deliver the hydration benefits of Emulsion and Lotion in <span style="font-weight: 600;">one refined step</span> for <span style="font-weight: 600;">smoother, more supple, visibly radiant skin</span>.</p>
                        <p>Incorporating an <span style="font-weight: 600;">all-in-one essence</span> offers a refined approach to <span style="font-weight: 600;">beautifully balanced, healthier-looking skin</span>.</p>
                    `},
                    { name: '', desc: 'I\'m new to Japanese skincare rituals.', shopTag: 'dsk-quiz-layering-new', interstitialHtml: `
                        <p>In <span style="font-weight: 600;">Japanese skincare, hydration is not a single step</span>—it’s a <span style="font-weight: 600;">layering ritual</span> that brings skin into balance.</p>
                        <p>Inspired by this ritual, <span style="font-weight: 600;">DECORTÉ's advanced all-in-one essences</span> deliver the hydration benefits of Emulsion and Lotion in <span style="font-weight: 600;">one refined step</span> for <span style="font-weight: 600;">smoother, more supple, visibly radiant skin</span>.</p>
                        <p>Incorporating an <span style="font-weight: 600;">all-in-one essence</span> offers a refined approach to <span style="font-weight: 600;">beautifully balanced, healthier-looking skin</span>.</p>
                    `}
                ]
            },
            {
                step: 7,
                type: question_types.MULTIPLE_ICONS_1_ROW,
                text: 'How much do lifestyle factors affect your skin?',
                subtitle: 'Choose as many as apply.',
                options: [
                    { name: 'I sleep well & manage stress', desc: '', shopTag: 'dsk-quiz-life-sleep-well', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-sleep-well.png?v=1777300755' },
                    { name: 'I\'m often stressed/sleep-deprived', desc: '', shopTag: 'dsk-quiz-life-stressed', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-stressed.png?v=1777300755' },
                    { name: 'Travel frequently', desc: '', shopTag: 'dsk-quiz-life-travel-frequently', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-travel.png?v=1777300823' },
                    { name: 'Spend a lot of time outdoors', desc: '', shopTag: 'dsk-quiz-life-time-outdoors', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-outdoors.png?v=1777300823' }
                ]
            },
            {
                step: 8,
                text: 'How would you describe your current skincare ritual?',
                type: question_types.SINGLE_IMG_1_ROW,
                options: [
                    { name: 'Moderate', desc: 'I use 2-4 products.', shopTag: 'dsk-quiz-ritual-moderate', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-ritual-4-steps.png?v=1779291506' },
                    { name: 'Advanced', desc: 'I use 6+ products.', shopTag: 'dsk-quiz-ritual-advanced', img: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-ritual-6plus-steps.png?v=1779291697' }
                ]
            },
            {
                step: 9,
                type: question_types.SINGLE_1_COL,
                text: 'How often do you use SPF?',
                subtitle: '',
                ctaTitle: 'Why we ask this',
                infoImage: 'https://cdn.shopify.com/s/files/1/0350/4095/2456/files/dsk-quiz-spf-overlay.png?v=1782835944',
                infoText: '<p><span style="font-weight: 600;">Daily sun exposure</span> is one of the <span style="font-weight: 600;">primary factors influencing visible skin aging</span> and overall skin condition. In <span style="font-weight: 600;">Japanese skincare, protecting</span> the skin from UV exposure is an <span style="font-weight: 600;">essential daily practice</span>. Understanding your sunscreen habits helps us guide a ritual that <span style="font-weight: 600;">supports and protects your skin over time</span>.</p>',
                options: [
                    { name: 'Daily', desc: '', shopTag: 'dsk-quiz-spf-daily' },
                    { name: 'Sometimes', desc: '', shopTag: 'dsk-quiz-spf-sometimes' },
                    { name: 'Only when outdoors', desc: '', shopTag: 'dsk-quiz-spf-only-sun' },
                    { name: 'Never', desc: '', shopTag: 'dsk-quiz-spf-never' }
                ]
            }
        ],
        answers: {},
        api_results: [],
        errorMessage: '',
        subtitleLimitWarning: false,
        limitReached: false,
        infoOverlayOpen: false,
        emailCaptureVisible: true,
        atcLoading: false,
        atcSingleLoadingId: null,
        atcErrorOpen: false,
        atcRetry: null,
        uncheckedProductIds: {},
        selectedVariantIds: {},
        switchRoutine(routine) {
            this.activeRoutine = routine;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        toggleProductCheck(productId) {
            const updated = { ...this.uncheckedProductIds };
            if (updated[productId]) {
                delete updated[productId];
            } else {
                updated[productId] = true;
            }
            this.uncheckedProductIds = updated;
        },
        setSelectedVariantId(productId, variantId) {
            this.selectedVariantIds = { ...this.selectedVariantIds, [productId]: variantId };
        },
        get addAllButtonLabel() {
            const seenIds = new Set();
            let total = 0;
            let currencyCode = 'USD';
            ['AM', 'PM'].forEach(routine => {
                (this.ritualStepGroups[routine] || []).forEach(group => {
                    group.products.forEach(product => {
                        if (!product || product.isEmpty) return;
                        if (seenIds.has(product.id)) return;
                        seenIds.add(product.id);
                        if (this.uncheckedProductIds[product.id]) return;
                        const variantId = this.selectedVariantIds[product.id] || product.variants?.[0]?.id;
                        const variant = product.variants?.find(v => v.id === variantId) || product.variants?.[0];
                        total += parseFloat(variant?.price?.amount || product.priceRange?.minVariantPrice?.amount || 0);
                        currencyCode = variant?.price?.currencyCode || product.priceRange?.minVariantPrice?.currencyCode || currencyCode;
                    });
                });
            });
            const label = this.atcLoading
                ? 'ADDING TO CART...'
                : (Object.keys(this.uncheckedProductIds).length === 0 ? 'ADD AM & PM RITUAL TO CART' : 'ADD SELECTED TO CART');
            return `${this.formatPrice(total, currencyCode)} | ${label}`;
        },
        restartQuiz() {
            this.footerObserver?.disconnect();
            this.footerObserver = null;
            if (this.footerScrollHandler) {
                window.removeEventListener('scroll', this.footerScrollHandler);
                this.footerScrollHandler = null;
            }
            clearTimeout(this.footerScrollSettleTimer);
            const footer = document.querySelector('.dsk-quiz-sticky-footer');
            footer?.classList.remove('footer-hidden');
            footer?.classList.remove('is-scrolling');
            this.footerHidden = false;
            this.currentStep = 0;
            this.quizCompleted = false;
            this.apiError = false;
            this.answers = {};
            this.api_results = [];
            this.errorMessage = '';
            this.limitReached = false;
            this.subtitleLimitWarning = false;
            this.infoOverlayOpen = false;
            this.interstitialOpen = false;
            this.currentInterstitialHtml = '';
            this.emailCaptureVisible = true;
            this.fetchSunscreenProduct();
            this.activeRoutine = 'AM';
            this.ritualProducts = { 'AM': [], 'PM': [] };
            this.ritualStepGroups = { 'AM': [], 'PM': [] };
            this.ritualCollection = { 'AM': null, 'PM': null };
            this.preResultsVisible = false;
            // signupComplete is deliberately NOT reset: a visitor who subscribed
            // stays on the thanks view for later retakes, instead of being shown
            // the signup embed again in whatever post-submit state Klaviyo left it.
            this.resultStepLabels = ['Cleanse', 'Repair', 'Moisturize', 'Eye Care'];
            this.atcLoading = false;
            this.atcSingleLoadingId = null;
            this.atcErrorOpen = false;
            this.atcRetry = null;
            this.uncheckedProductIds = {};
            this.selectedVariantIds = {};
            // Wait for Alpine to swap the (tall) results markup for the (short) landing
            // markup before scrolling — otherwise the in-flight smooth-scroll gets
            // clamped to the new, shorter page height and lands on the footer.
            this.$nextTick(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
        },
        _parseVariantId(gid) {
            if (!gid) return null;
            const parts = String(gid).split('/');
            return parts[parts.length - 1];
        },
        openAtcError(retry) {
            this.atcRetry = retry;
            this.atcErrorOpen = true;
        },
        closeAtcError() {
            this.atcErrorOpen = false;
            this.atcRetry = null;
        },
        retryAtc() {
            const retry = this.atcRetry;
            this.closeAtcError();
            if (retry) retry();
        },
        _openCartDrawerAfterAdd() {
            // The Prestige theme renders the cart drawer once at page load and only
            // re-renders it when a `cart:refresh` event is dispatched on document
            // (its CartDrawer, CartCount and CartDot components all listen for it).
            // Dispatch it, then wait for the drawer's `cart-drawer:refreshed` event
            // (or a short fallback) before opening so it doesn't show stale contents.
            return new Promise(resolve => {
                const toggle = document.querySelector('[aria-controls="cart-drawer"]') || document.querySelector('[href="/cart"]');
                let settled = false;
                const open = () => {
                    if (settled) return;
                    settled = true;
                    toggle?.click();
                    resolve();
                };
                document.addEventListener('cart-drawer:refreshed', open, { once: true });
                setTimeout(open, 1000);
                document.dispatchEvent(new CustomEvent('cart:refresh'));
            });
        },
        async addToCart(variantId, quantity) {
            const id = this._parseVariantId(variantId);
            if (!id || this.atcSingleLoadingId) return;
            this.atcSingleLoadingId = variantId;
            try {
                const res = await fetch(window.location.origin + '/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: [{ id, quantity: quantity || 1 }] })
                });
                if (res.ok) {
                    await this._openCartDrawerAfterAdd();
                } else {
                    console.error('Add to cart failed:', await res.json());
                    this.openAtcError(() => this.addToCart(variantId, quantity));
                }
            } catch (e) {
                console.error('Add to cart error:', e);
                this.openAtcError(() => this.addToCart(variantId, quantity));
            } finally {
                this.atcSingleLoadingId = null;
            }
        },
        async addAllToCart() {
            if (this.atcLoading) return;
            this.atcLoading = true;

            // Read selected variant IDs and quantities from the visible routine's DOM.
            const domVariants = {};
            document.querySelectorAll('.dsk-quiz-product-grid .dsk-quiz-product-card').forEach(card => {
                const checkbox = card.querySelector('.dsk-quiz-results-checkbox');
                if (!checkbox) return;
                const productId = checkbox.id.replace(/^select-/, '');
                if (!productId) return;
                const variantId = this._parseVariantId(card.dataset.variantId);
                const qty = parseInt(card.dataset.quantity, 10) || 1;
                if (variantId) domVariants[productId] = { variantId, qty };
            });

            // Iterate both routines; deduplicate by product ID so overlapping products are added once.
            const seenProductIds = new Set();
            const items = [];
            ['AM', 'PM'].forEach(routine => {
                (this.ritualStepGroups[routine] || []).forEach(group => {
                    group.products.forEach(product => {
                        if (!product || product.isEmpty) return;
                        if (seenProductIds.has(product.id)) return;
                        if (this.uncheckedProductIds[product.id]) return;
                        seenProductIds.add(product.id);
                        if (domVariants[product.id]) {
                            // Use the variant the user selected in the visible dropdown
                            items.push({ id: domVariants[product.id].variantId, quantity: domVariants[product.id].qty });
                        } else {
                            // Hidden routine: use tracked selectedVariantIds or fall back to first variant
                            const selectedId = this.selectedVariantIds[product.id] || product.variants?.[0]?.id;
                            const variantId = this._parseVariantId(selectedId);
                            if (variantId) items.push({ id: variantId, quantity: 1 });
                        }
                    });
                });
            });

            if (!items.length) { this.atcLoading = false; return; }
            try {
                const res = await fetch(window.location.origin + '/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items })
                });
                if (res.ok) {
                    await this._openCartDrawerAfterAdd();
                } else {
                    console.error('Add all to cart failed:', await res.json());
                    this.openAtcError(() => this.addAllToCart());
                }
            } catch (e) {
                console.error('Add all to cart error:', e);
                this.openAtcError(() => this.addAllToCart());
            } finally {
                this.atcLoading = false;
            }
        },
    };
    })
})
